/* [Tema Shopify, Claude Code 2026-10-05] Copia adaptada de la web. AS_A = carpeta de
   archivos del tema; window.AS lo escribe el layout con lo que se edita en Shopify. */
var AS = window.AS || {};
var AS_A = AS.assets || 'assets/';
/* =========================================================
   Código compartido: íconos, cabecera, pie, animaciones.
   Cambia aquí el nombre de la tienda y la fecha de la oferta.
   ========================================================= */
const STORE = {
  name: 'Allsupletion',
  slogan: 'Complementa tu día. Mejora tu versión.',
  // Personajes creados con IA SOLO para ver el diseño. Antes de publicar la
  // tienda: poner en false (se ocultan) o reemplazarlos por clientes reales.
  demoPersonas: true,
  // [2026-09-20] se quitó `whatsapp`: la tienda ya no usa WhatsApp (decisión de Jacsson)
  // Contacto de las políticas (politicas.html). ⚠️ TEMPORAL: es el correo de TensiOff.
  // Cambiarlo por el correo de Allsupletion al publicar en Shopify (pedido de Jacsson, 2026-09-17).
  /* [2026-10-02] Era contacto.tensioff@gmail.com, el del OTRO proyecto: el
     cliente de Allsupletion habría escrito a la tienda equivocada. Jacsson está
     creando esta casilla ahora.
     ⚠️ CONFIRMAR QUE EXISTE antes de publicar en Shopify: va en las políticas,
     y una casilla que rebota es peor que no poner ninguna. */
  email: 'contacto.allsupletion@gmail.com',
  address: 'Las Acacias #942, Las Condes, Santiago',
  // El número del cartel flotante: es el premio MÁS ALTO que se puede ganar, y
  // por eso va con "hasta". Tiene que coincidir con el mayor de REPARTOS: si dice
  // más de lo que se puede ganar es publicidad engañosa, y por ahí Meta baja
  // cuentas publicitarias. Crear los mismos códigos en Shopify.
  welcomeMax: 40,
  welcomeCode: 'BIENVENIDA10',
  // ─── LA OFERTA: los 3 datos que hay que cambiar cuando se renueva ───
  // [2026-09-27] Antes era "Oferta de lanzamiento" y terminaba el 30 de
  // septiembre. Se cambió de temática porque las fiestas patrias ya pasaron.
  // El ángulo ahora es la primavera: el verano es en diciembre, y octubre y
  // noviembre son los meses en que la gente retoma la rutina.
  // El nombre está SOLO aquí: se usa en los kits, en las fichas y en el inicio.
  // [2026-09-29] offerName / offerWhy / offerEnd / offerEndText YA NO SE ESCRIBEN
  // aquí: los pone la campaña activa (ver CAMPANAS, más abajo).
  // Estos valores son la RED DE SEGURIDAD para cuando no hay ninguna campaña
  // viva: son neutros, sin temporada, y la fecha está vencida a propósito para
  // que la barra de oferta se esconda sola en vez de anunciar algo que terminó.
  offerName: 'Oferta de bienvenida',
  offerWhy: 'Estos son nuestros primeros pedidos, y por eso el precio está así.',
  // Fecha REAL de término (hora de Chile). El contador no se reinicia:
  // cuando pasa la fecha, se oculta solo.
  // [2026-09-28] Se acortó del 31 al 25 de octubre (decisión de Jacsson) para
  // dejarle espacio a la campaña de fin de octubre. El 31 de octubre (sábado) y
  // el 1 de noviembre (domingo) son los dos feriados: la campaña de esa fecha
  // tiene que estar viva ANTES, no empezar el mismo día. Terminando primavera el
  // domingo 25, el lunes 26 arranca la siguiente y no queda ni un día sin oferta.
  // [anterior] offerEnd: '2026-10-31T23:59:00-03:00' / offerEndText: '31 de octubre'
  offerEnd: '2000-01-01T00:00:00-03:00',
  offerEndText: '',
};

/* ═══ LAS CAMPAÑAS ═══════════════════════════════════════════════════════════
   [2026-09-29] Antes la campaña estaba escrita a mano dentro de STORE y había
   que acordarse de cambiarla el día exacto. Ahora son una lista con fecha y la
   página elige sola.

   CÓMO ELIGE: la activa es la PRIMERA cuya fecha de término todavía no pasa.
   Como están en orden, el 25 de octubre a las 23:59 se acaba la primavera y el
   26 amanece con Halloween. No hay que tocar nada ese día.

   PARA VERLA ANTES: agrega ?campana=halloween a la dirección. Sirve para
   revisarla hoy sin cambiarle la campaña a nadie.

   PARA AGREGAR UNA: pégala al final de la lista, en orden de fecha. Nada más.
   Estos 4 datos se copian a STORE, así que todo lo que ya los usaba (los kits,
   las fichas, el contador y la barra de arriba) sigue funcionando igual. */
if (AS.store) Object.assign(STORE, AS.store);

const CAMPANAS_WEB = [
  {
    /* ⚠️ CYBERMONDAY CHILE 2026: lunes 5, martes 6 y miércoles 7 de octubre.
       Fechas confirmadas, ya estaban investigadas en la bóveda
       (01 - 📝 Mis Notas/📜 Bitácora de Decisiones, 2026-09-xx).

       OJO CON EL NOMBRE: el de octubre en Chile es el **CyberMonday**. El
       CyberDay es en mayo/junio. La nota de publicidad de Allsupletion lo tiene
       mal escrito como "CyberDay (5-7 oct)"; la de TensiOff lo tiene bien.

       Va PRIMERA porque la lista se recorre en orden y gana la primera que
       todavía no vence. El 8 de octubre a las 00:00 esta vence sola y entra la
       que sigue, sin que nadie toque nada. */
    id: 'cyber',
    nombre: 'CyberMonday',
    /* [2026-10-03] Jacsson: *"seguimos con el Cyber Monday y lo alargamos hasta
       el 10"*. Después entra Halloween sola.
       [anterior: Claude Code] hasta '2026-10-07T23:59:00-03:00' · hastaTexto
       '7 de octubre' · porque 'Lo adelantamos: empieza antes y termina igual el
       miércoles a medianoche.' */
    /* [2026-10-03, corrección de Jacsson] *"el Cyber normal dura hasta el 7"*:
       hasta el 7 TODO dice "hasta el 7" (barra, contador, banners). Recién el 8
       aparece que lo alargamos. `hasta` (el 10) solo decide hasta cuándo vive la
       campaña; lo que VE el cliente lo pone `hastaVisible` y cada fase.
       [anterior: Claude Code, misma noche] hastaTexto '10 de octubre' y porque
       'Lo adelantamos y lo alargamos…' desde el primer día. */
    hasta: '2026-10-10T23:59:00-03:00',
    hastaVisible: '2026-10-07T23:59:00-03:00',
    hastaTexto: '7 de octubre',
    porque: 'Lo adelantamos: empieza antes y termina igual el miércoles a medianoche.',
    /* [2026-10-02] Jacsson: *"debemos anunciar que nos adelantamos al cyber… y la
       fecha de término también"*. `adelanto` reemplaza al nombre en la barra y
       `barra` reemplaza la frase de la derecha. Las dos cosas en una sola línea,
       porque la barra es una tira de una línea: si se le mete un párrafo, en
       celular se parte y no se lee ninguna. */
    adelanto: 'Nos adelantamos al CyberMonday',
    barra: '2x1 en productos seleccionados · hasta el miércoles 7',
    /* [2026-10-03] La barra cambia sola en cada etapa del Cyber alargado: antes
       del 5 "nos adelantamos", del 5 al 7 el Cyber oficial y del 8 al 10
       "extendido". [anterior: Claude Code] barra '… · hasta el miércoles 7' */
    fases: [
      { desde: '2026-10-05T00:00:00-03:00', adelanto: 'CyberMonday', barra: '2x1 en productos seleccionados · solo hasta el miércoles 7' },
      /* Del 8 al 10: el mensaje que pidió Jacsson, "porque entendemos tu situación
         alargamos el Cyber hasta el 10". */
      { desde: '2026-10-08T00:00:00-03:00', adelanto: 'Te entendemos', barra: 'Alargamos el Cyber y el 2x1 hasta el sábado 10',
        hastaVisible: '2026-10-10T23:59:00-03:00', hastaTexto: '10 de octubre',
        porque: 'Sabemos que no todos alcanzaron: solo nosotros alargamos el Cyber hasta el sábado 10 a medianoche.' },
    ],
    juego: {
      kicker: 'Cyber',
      titulo: 'Elige <em>3 de 10</em>',
      bajada: 'Las diez cartas tienen premio. Descuento en tu <b>segunda unidad</b>, y si las tres salen iguales te llevas ese premio.',
    },
  },
  {
    /* Del 26 de octubre al 1 de noviembre: 7 días.
       El 31 (sábado) y el 1 (domingo) son feriados, así que es el último fin de
       semana largo antes del verano. Ese es el motivo que se le da al cliente:
       la fecha, no el susto. */
    id: 'halloween',
    nombre: 'Ofertas de miedo',
    hasta: '2026-11-01T23:59:00-03:00',
    hastaTexto: '1 de noviembre',
    porque: 'El domingo 1 de noviembre a medianoche los precios vuelven a los de siempre. Son siete días, y el descuento que saques se aplica en esta misma compra.',
    juego: {
      kicker: 'Dulce o truco',
      titulo: 'Elige <em>3 de 10</em>',
      bajada: 'Sin trucos: las diez son dulces. Descuento en tu <b>segunda unidad</b>, y si las tres salen iguales te llevas ese premio.',
    },
  },
  {
    /* [2026-10-01] RETIRADA, no borrada. Con el CyberMonday hasta el 7 y
       Halloween desde el 8, esta campaña ya no alcanza a salir: Jacsson pidió
       *"apenas termine el cyber activamos el modo Halloween"*. Se deja escrita
       y DESPUÉS de Halloween en la lista, así nunca gana pero queda de
       respaldo si algún día hay que volver a ella. */
    id: 'primavera',
    nombre: 'Oferta de primavera',
    hasta: '2026-10-25T23:59:00-03:00',
    hastaTexto: '25 de octubre',
    porque: 'Empezó la primavera y el verano es en diciembre: es el mejor mes para armar la rutina. Además estos son nuestros primeros pedidos, y por eso el precio está así.',
  },
];

/* La campaña activa: la primera que todavía no vence.

   ⚠️ SI VENCIERON TODAS devuelve `null`, y entonces NO se toca STORE ni se
   decora nada. Es a propósito: si nadie agrega la campaña siguiente, el 2 de
   noviembre la tienda vuelve sola a su aspecto normal. Sin esto, los
   murciélagos y el "OFERTAS DE MIEDO" seguirían puestos en diciembre. */
/* ⚠️ VISTA PREVIA — QUITAR ANTES DE PUBLICAR LA TIENDA ⚠️
   [2026-09-29] Jacsson no podía ver Halloween: en el enlace del artifact la
   página va dentro del visor de Claude y el `?campana=` NO le llega, así que el
   truco de la dirección no sirve ahí.

   Con esto puesto, la campaña que diga acá manda por encima de la fecha.
   Para volver al comportamiento normal —que la campaña entre sola el 26 de
   octubre— basta poner `null`:

       const FORZAR = null;

   MIENTRAS ESTO NO SEA `null`, LA FECHA NO SE RESPETA. */
/* [2026-10-02] En null: manda la fecha. Hoy es 2 de octubre y la campaña
   `cyber` vence el 7, así que el CyberMonday YA está activo — Jacsson pidió
   adelantarlo: *"el cyber lo empezaremos antes y listo… inclusive lo podríamos
   anunciar"*. El 8 a las 00:00 entra Halloween sin tocar nada.
   ⚠️ Volver a poner un id aquí SOLO para ver una campaña fuera de su fecha, y
   dejarlo en null antes de publicar. */
const CAMPANAS = (AS.campanas && AS.campanas.length) ? AS.campanas : CAMPANAS_WEB;
const FORZAR = null;

const campanaActiva = () => {
  if (FORZAR) return CAMPANAS.find((x) => x.id === FORZAR) || null;
  let forzada = null;
  try { forzada = new URLSearchParams(location.search).get('campana'); } catch (e) { /* sin URL */ }
  if (forzada) return CAMPANAS.find((x) => x.id === forzada) || null;
  const hoy = Date.now();
  return CAMPANAS.find((c) => new Date(c.hasta).getTime() > hoy) || null;
};

const CAMPANA = campanaActiva() || { id: '', juego: null };
if (CAMPANA.id) {
  /* [2026-10-03] Primero la fase vigente: puede cambiar la fecha que se muestra.
     Se escribe sobre CAMPANA porque el texto de los banners lee CAMPANA.hastaTexto. */
  (CAMPANA.fases || []).forEach((f) => {
    if (Date.now() >= new Date(f.desde).getTime()) {
      ['hastaVisible', 'hastaTexto', 'porque'].forEach((k) => { if (f[k]) CAMPANA[k] = f[k]; });
    }
  });
  STORE.offerName = CAMPANA.nombre;
  STORE.offerWhy = CAMPANA.porque;
  STORE.offerEnd = CAMPANA.hastaVisible || CAMPANA.hasta;   // [anterior] CAMPANA.hasta
  STORE.offerEndText = CAMPANA.hastaTexto;
  /* [2026-10-02] Los dos textos de la barra, si la campaña los trae. Sin esto
     la barra sigue mostrando el nombre de la campaña y la frase de siempre. */
  if (CAMPANA.adelanto) STORE.adelanto = CAMPANA.adelanto;
  if (CAMPANA.barra) STORE.barra = CAMPANA.barra;
  /* La última fase que ya empezó manda sobre adelanto y barra. */
  (CAMPANA.fases || []).forEach((f) => {
    if (Date.now() >= new Date(f.desde).getTime()) { STORE.adelanto = f.adelanto; STORE.barra = f.barra; }
  });
}

/* La marca en el <body> es lo que enciende los adornos del CSS. Se pone cuanto
   antes —sin esperar a que cargue todo— para que no se vea un parpadeo con la
   página sin decorar. */
(function marcaCampana() {
  const pon = () => { if (document.body && CAMPANA.id) document.body.dataset.campana = CAMPANA.id; };
  pon();
  if (!document.body) document.addEventListener('DOMContentLoaded', pon);
})();

/* ---------- las fotos de los productos --------------------------------------
   [2026-09-28] Las fotos de la tienda son las que hicimos nosotros: estan en
   ${AS_A}img-productos-, una por id de Dropi, 1200x1200 y con el fondo blanco
   puro. Son la UNICA fuente de fotos de producto de toda la web.

   [anterior: recortes con fondo transparente, 2026-09-27] habia un mapa RECORTES
   con 6 productos que se servian desde ${AS_A}img-kit-. Se descarto el 2026-09-28:
   esos recortes estaban mal hechos (sombra pegada, relleno a medias y agujeros
   dentro del envase) y Jacsson pidio usar directamente las fotos ya creadas en
   vez de seguir arreglando recortes. Los archivos de img/kit/ se conservan.

   Para sumar un producto: deja su foto como ${AS_A}img-productos-<id>.webp y
   .jpg, y agrega el id a FOTOS. No hay que tocar nada mas. */
const FOTOS = [
  23482, 35868, 37301, 46242, 48056, 49208, 50838, 54685, 54979, 57201, 58061,
  59438, 61032, 63663, 63664, 64268, 64269, 65555, 67632, 72695, 72696, 72697,
  72944, 72945, 83439, 84072, 84659, 87268, 89150, 91095, 91096, 91660, 95120,
  96342, 96539, 96541, 96544, 97448, 103967, 125745, 125747, 125749, 126340, 158579,
];

/* Los kits se arman por nombre, no por id (ver kits.js), asi que necesitan esta
   traduccion. Son los 6 productos de los dos kits. */
const FOTO_POR_NOMBRE = {
  shilajit: 83439,      // Gomitas de shilajit (Buporai)
  turkesterona: 91096,  // Turkesterona (Old School)
  nad: 125747,          // NAD+ para hombres (Selerb)
  creatina: 64268,      // Creatina para mujer (Old School)
  colageno: 84659,      // Colágeno en péptidos (Toplux)
  magnesio: 126340,     // Magnesio 12 en 1 (Totaria)
};

/* [2026-09-28] El recorte sin fondo, para las páginas de kit.
   Ahí la tarjeta tiene color propio (negro en Energía, rosado en Mujer) y una
   foto con el fondo blanco pintado deja un cuadrado blanco alrededor del frasco.
   Los 6 recortes los hizo Jacsson y están en ${AS_A}img-kit-.
   Solo sirve para los 6 productos de los kits: el catálogo sigue con las fotos
   sobre blanco, que ahí es lo correcto. */
const fotoSinFondo = (ref, alt, lazy = true) => {
  const n = typeof ref === 'string' ? ref : RECORTE_POR_ID[ref];
  if (!n) return null;
  return `<picture><source srcset="${AS_A}img-kit-${n}.webp" type="image/webp"><img src="${AS_A}img-kit-${n}.png" alt="${alt}" width="1200" height="1200"${lazy ? ' loading="lazy"' : ''} decoding="async"></picture>`;
};
const RECORTE_POR_ID = Object.fromEntries(
  Object.entries(FOTO_POR_NOMBRE).map(([n, id]) => [id, n]));

/* Devuelve la foto limpia de un producto, por id o por nombre de kit.
   Si no tenemos foto propia devuelve null, y quien llama pone su respaldo. */
const fotoProducto = (ref, alt, lazy = true) => {
  const id = typeof ref === 'string' ? FOTO_POR_NOMBRE[ref] : ref;
  if (!FOTOS.includes(id)) return null;
  return `<picture><source srcset="${AS_A}img-productos-${id}.webp" type="image/webp"><img src="${AS_A}img-productos-${id}.jpg" alt="${alt}" width="1200" height="1200"${lazy ? ' loading="lazy"' : ''} decoding="async"></picture>`;
};

const ICONS = {
  truck: '<path d="M2 6h11v10H2z"/><path d="M13 9h4.5L21 12.5V16h-8z"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
  cash: '<rect x="2.5" y="6" width="19" height="12" rx="2"/><circle cx="12" cy="12" r="2.6"/><path d="M6 9.5v5M18 9.5v5"/>',
  shield: '<path d="M12 3l7.5 3v5.5c0 4.6-3.2 8.3-7.5 9.5-4.3-1.2-7.5-4.9-7.5-9.5V6z"/><path d="M8.8 12.2l2.2 2.2 4.3-4.6"/>',
  box: '<path d="M3.5 7.5L12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5L12 12l8.5-4.5M12 12v9"/>',
  lock: '<rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V7.5a4 4 0 018 0v3"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/>',
  bolt: '<path d="M13 2.5L4.5 13.5H11l-1 8 8.5-11H12z"/>',
  moon: '<path d="M20 14.5A8.5 8.5 0 119.5 4a7 7 0 0010.5 10.5z"/>',
  leaf: '<path d="M5 19c0-8 5.5-14 15-14 0 9.5-6 15-14 15"/><path d="M5 19c3-4 6-6.5 10-8.5"/>',
  flame: '<path d="M12 3c1 3.5 5 5.5 5 10.5a5 5 0 01-10 0c0-2.5 1.3-4 2.5-5 .3 1.8 1.2 2.8 2.5 3.2C11.5 9 11 6 12 3z"/>',
  hourglass: '<path d="M6.5 3h11M6.5 21h11"/><path d="M7.5 3c0 4.5 4.5 6 4.5 9s-4.5 4.5-4.5 9M16.5 3c0 4.5-4.5 6-4.5 9s4.5 4.5 4.5 9"/>',
  move: '<path d="M3 12h4l2.5-6 5 12 2.5-6H21"/>',
  star: '<path fill="currentColor" stroke="none" d="M12 2.8l2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2l-5.7 3.1 1.2-6.4-4.7-4.4 6.4-.8z"/>',
  check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
  x: '<path d="M6 6l12 12M18 6L6 18"/>',
  arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  cart: '<path d="M3 4h2.5l2.2 11h10.6l2-8H6.3"/><circle cx="9.5" cy="19" r="1.4"/><circle cx="17" cy="19" r="1.4"/>',
  card: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 9h18M7 15h4"/>',
  camera: '<path d="M4 8h3l2-2.5h6L17 8h3v11H4z"/><circle cx="12" cy="13" r="3.5"/>',
  sofa: '<path d="M4 11V8a2 2 0 012-2h12a2 2 0 012 2v3"/><path d="M2.5 12.5a1.5 1.5 0 013 0V15h13v-2.5a1.5 1.5 0 013 0V18h-19z"/><path d="M5 18v2M19 18v2"/>',
  ball: '<circle cx="12" cy="12" r="9"/><path d="M12 7.5l4 2.9-1.5 4.6h-5L8 10.4z"/><path d="M12 3v4.5M16 10.4l4.6-1.5M14.5 15l2.8 4M9.5 15l-2.8 4M8 10.4L3.4 8.9"/>',
  briefcase: '<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M9 7V5h6v2M3 12.5h18"/>',
  dumbbell: '<path d="M6.5 6.5v11M17.5 6.5v11M3.5 9v6M20.5 9v6M6.5 12h11"/>',
  users: '<circle cx="9" cy="8" r="3"/><path d="M3.5 20c0-3.3 2.5-6 5.5-6s5.5 2.7 5.5 6"/><circle cx="17" cy="10" r="2.2"/><path d="M15.5 14.6c2.8-.6 5 1.6 5 4.4"/>',
  sun: '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8"/>',
  home: '<path d="M3.5 11L12 4l8.5 7"/><path d="M5.5 9.5V20h13V9.5"/>',
  calendar: '<rect x="3.5" y="5" width="17" height="15.5" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/>',
  heart: '<path d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0112 7a4.3 4.3 0 017.5 2.8C19.5 15.4 12 20 12 20z"/>',
  gift: '<rect x="3.5" y="8" width="17" height="4" rx="1"/><path d="M5 12v8.5h14V12M12 8v12.5"/><path d="M12 8c-1.5-3.5-5.5-4-5.5-1.5S10 8 12 8zM12 8c1.5-3.5 5.5-4 5.5-1.5S14 8 12 8z"/>',
  glass: '<path d="M6 3h12l-1.5 17.5h-9z"/><path d="M6.6 9h10.8"/>',
  user: '<circle cx="12" cy="8" r="3.5"/><path d="M5 20.5c0-3.9 3.1-7 7-7s7 3.1 7 7"/>',
  tag: '<path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8.5" r="1.4"/>',
  menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
  chevron: '<path d="M6 9.5l6 6 6-6"/>',
  swap: '<path d="M8 7l-4 5 4 5M16 7l4 5-4 5"/>',
  sparkle: '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/><path d="M19 16l.8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8z"/>',
};
function ic(name, cls = '') {
  return `<svg class="${cls}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${ICONS[name] || ''}</svg>`;
}
const stars = () => `<span class="stars" aria-label="5 estrellas">${ic('star').repeat(5)}</span>`;
const clp = (n) => '$' + n.toLocaleString('es-CL');

/* logo monocromático: oscuro en fondos claros, claro en el kit Energía */
function logoImg() {
  const light = document.body.classList.contains('t-energia');
  return `<img class="logo-img" src="${AS_A}img-${light ? 'logo-light' : 'logo-dark'}.png" alt="${STORE.name}" width="720" height="${light ? 140 : 136}">`;
}

/* ---------- barra superior, cabecera y pie ---------- */
/* ---------- menú de la tienda -----------------------------------------
   Antes de esto, bajo 860 px NO había ningún menú: solo el logo y tres
   iconos. Quien entraba por el celular —la mayoría— no tenía forma de ver
   las categorías. Por eso el botón de hamburguesa es lo importante aquí,
   no el desplegable de escritorio.

   Las categorías salen de CATS y los números de PRODUCTS (assets/productos.js),
   así que nunca quedan desfasados del catálogo. Si esa lista no está cargada
   en la página, el panel se arma igual pero sin categorías: no se inventa
   ninguna. Por eso productos.js ahora se carga en TODAS las páginas.
   -------------------------------------------------------------------- */
function menuPanel() {
  const hayCatalogo = typeof CATS !== 'undefined' && typeof PRODUCTS !== 'undefined';
  let cats = '';
  let total = 0;
  if (hayCatalogo) {
    const vivos = PRODUCTS.filter((p) => !APARTADOS.includes(p.id));
    total = vivos.length;
    cats = CATS.map((c) => {
      const n = vivos.filter((p) => p.cat === c.id).length;
      return `<li><a href="productos.html?cat=${c.id}" style="--pc:${c.c}">
        <span class="mm-ic">${ic(c.ic)}</span>
        <span class="mm-name">${c.name}</span>
        <span class="mm-n">${n}</span>
      </a></li>`;
    }).join('');
  }

  return `<div class="megamenu" id="menu-tienda" hidden>
    <div class="mm-wrap mm-grid">
      ${cats ? `<div class="mm-col mm-cats">
        <h4>Por lo que necesitas</h4>
        <ul>${cats}</ul>
      </div>` : ''}
      <div class="mm-col">
        <h4>Para quién</h4>
        <ul class="mm-plain">
          <li><a href="productos.html?sexo=M">${ic('heart')}Para mujer</a></li>
          <li><a href="productos.html?sexo=H">${ic('user')}Para hombre</a></li>
        </ul>
        <h4>Rutinas armadas</h4>
        <ul class="mm-plain">
          <li><a href="kit-energia.html">${ic('bolt')}Kit Energía Hombre 40+</a></li>
          <li><a href="kit-mujer.html">${ic('sparkle')}Kit Mujer Fuerte</a></li>
          <li><a href="test.html">${ic('swap')}No sé cuál me sirve</a></li>
        </ul>
      </div>
    </div>
    <div class="mm-wrap">
      <a class="mm-all" href="productos.html">Ver ${total ? 'los ' + total : 'todos los'} productos${ic('arrow')}</a>
    </div>
  </div>`;
}

function menuTienda() {
  const panel = document.getElementById('menu-tienda');
  const fondo = document.querySelector('[data-menu-fondo]');
  if (!panel) return;
  const botones = () => document.querySelectorAll('[data-menu]');
  let abierto = false;

  function pon(v) {
    if (v === abierto) return;
    abierto = v;
    // `hidden` primero para que la transición tenga de dónde partir
    if (v) { panel.hidden = false; if (fondo) fondo.hidden = false; }
    /* [2026-10-05 Claude Code] En celular el alto máximo del CSS (100dvh − 56px) no contaba las barras de
       oferta que hay sobre la cabecera: el panel terminaba bajo el borde y «Ver los N productos» no se
       alcanzaba. Se mide desde donde empieza el panel hasta el borde de la pantalla. */
    if (v) panel.style.maxHeight = innerWidth < 860 ? Math.max(240, innerHeight - panel.getBoundingClientRect().top) + 'px' : '';
    requestAnimationFrame(() => {
      panel.classList.toggle('open', v);
      if (fondo) fondo.classList.toggle('open', v);
    });
    if (!v) setTimeout(() => {
      if (!abierto) { panel.hidden = true; if (fondo) fondo.hidden = true; }
    }, 260);
    document.body.classList.toggle('menu-abierto', v);
    botones().forEach((b) => b.setAttribute('aria-expanded', v));
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu]')) { pon(!abierto); return; }
    if (!abierto) return;
    // un enlace del panel cierra; un clic fuera también
    if (e.target.closest('#menu-tienda a') || !e.target.closest('#menu-tienda')) pon(false);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') pon(false); });
  addEventListener('resize', () => pon(false));
}

function chrome() {
  const page = document.body.dataset.page;
  if (!document.querySelector('link[rel="icon"]')) {
    document.head.insertAdjacentHTML('beforeend', '<link rel="icon" type="image/png" href="' + AS_A + 'img-favicon-64.png"><link rel="apple-touch-icon" href="' + AS_A + 'img-favicon-180.png">');
  }
  const items = [
    ['truck', 'Envío gratis a todo Chile'],
    ['cash', 'Paga en tu casa al recibir'],
    ['shield', 'Garantía de 30 días'],
    ['clock', 'Despacho en 24–48 h'],
  ];
  const run = (AS.anuncios && AS.anuncios.length ? AS.anuncios : items).map(([i, t]) => `<span>${ic(i)}${t}</span>`).join('');
  const announce = document.querySelector('[data-announce]');
  if (announce) {
    announce.outerHTML = `<button class="offerbar" type="button" data-open-game data-countdown>
      <span><b>${(STORE.adelanto || STORE.offerName).toUpperCase()}</b> · ${STORE.barra || 'Envío gratis + guía de regalo'}</span>
      <span>Termina en <span class="cd">--</span></span>
    </button>
    <div class="announce" role="note"><div class="announce-track">${run.repeat(4)}</div></div>`;
  }

  const header = document.querySelector('[data-header]');
  if (header) {
    const cur = (p) => (page === p ? ' aria-current="page"' : '');
    header.outerHTML = `
    <header class="site-header">
      <div class="wrap">
        <button class="icon-btn menu-btn" type="button" aria-label="Abrir el menú de la tienda" aria-expanded="false" aria-controls="menu-tienda" data-menu>${ic('menu')}</button>
        <a class="logo" href="index.html" aria-label="${STORE.name}, inicio">${logoImg()}</a>
        <nav class="nav" aria-label="Principal">
          <a href="index.html"${cur('home')}>Inicio</a>
          <button class="nav-drop" type="button" aria-expanded="false" aria-controls="menu-tienda" data-menu>Productos${ic('chevron')}</button>
          <a href="kit-energia.html"${cur('energia')}>Kit Energía</a>
          <a href="kit-mujer.html"${cur('mujer')}>Kit Mujer Fuerte</a>
          <a href="test.html"${cur('test')}>Test</a>
        </nav>
        <div class="header-actions">
          <a class="icon-btn" href="productos.html" aria-label="Ver todos los productos">${ic('box')}</a>
          <a class="icon-btn" href="test.html" aria-label="Hacer el test">${ic('sparkle')}</a>
          <button class="icon-btn" type="button" aria-label="Carrito" data-cart>${ic('cart')}<span class="cart-count">0</span></button>
        </div>
      </div>
      ${menuPanel()}
    </header>
    <div class="menu-fondo" data-menu-fondo hidden></div>`;
  }

  const footer = document.querySelector('[data-footer]');
  if (footer) {
    const legal = footer.dataset.legal || 'Los productos de esta tienda son suplementos alimentarios; no son medicamentos. No están destinados a diagnosticar, tratar, curar ni prevenir enfermedades. No reemplazan una alimentación equilibrada. Consulte a su médico si está embarazada, en lactancia o toma medicamentos. Mantener fuera del alcance de los niños.';
    footer.outerHTML = `
    <footer class="site-footer">
      <div class="wrap">
        <div class="footer-grid">
          <div>
            <a class="logo" href="index.html" aria-label="${STORE.name}, inicio">${logoImg()}</a>
            <p style="margin-top:14px;max-width:34ch"><b style="color:var(--text)">${STORE.slogan}</b><br>Suplementos de varias marcas, ordenados por lo que necesitas. Una rutina, no un milagro.</p>
          </div>
          <div>
            <h4>Tienda</h4>
            <ul><li><a href="productos.html">Todos los productos</a></li><li><a href="kit-energia.html">Kit Energía Hombre 40+</a></li><li><a href="kit-mujer.html">Kit Mujer Fuerte</a></li><li><a href="test.html">Test: ¿qué necesitas?</a></li></ul>
          </div>
          <div>
            <h4>Ayuda</h4>
            <ul><li><a href="politicas.html#envios">Política de envíos</a></li><li><a href="politicas.html#reembolso">Política de reembolso</a></li><li><a href="politicas.html#privacidad">Privacidad</a></li><li><a href="politicas.html#terminos">Términos del servicio</a></li><li><a href="politicas.html#contacto">Contacto</a></li></ul>
            <!-- [anterior: Claude Code, 2026-09-15] los 5 enlaces apuntaban a "#" -->

          </div>
        </div>
        <p class="legal">${legal}</p>
        <p class="legal" style="border:0;margin-top:0;padding-top:6px">© 2026 ${STORE.name}. Todos los derechos reservados.</p>
      </div>
    </footer>`;
  }
}

/* ---------- guirnalda ----------
   [2026-09-27] Jacsson pidió sacar TODAS las banderas: pasaron las fiestas
   patrias. Se quitaron los 4 <div class="bunting"> del inicio y de los kits.
   La función y el CSS se dejan intactos a propósito, para poder volver a
   ponerlas en septiembre del próximo año agregando el div de nuevo. */
function bunting() {
  document.querySelectorAll('.bunting').forEach((b) => {
    b.setAttribute('aria-hidden', 'true');
    b.innerHTML = `<div class="bunting-row">${'<i></i>'.repeat(80)}</div>`;
  });
}

/* ---------- reseñas ------------------------------------------------------
   ⚠️ NINGUNA DE ESTAS RESEÑAS ES REAL. Son ejemplos para ver la sección
   terminada mientras no haya clientes. Por eso cada tarjeta lleva el letrero
   "Ejemplo · todavía no es una reseña de cliente" a la vista.

   [2026-09-20] Antes decían "Compra verificada". Eso se sacó: poner ese sello
   sobre una reseña inventada es afirmar algo falso, y es justo lo que revisa
   Meta cuando aprueba anuncios de suplementos. El sello vuelve cuando la
   reseña venga de un pedido de verdad.

   Cada reseña va amarrada a UN producto de los que salen en los banners del
   hero (los de SIN_PREMIO, en productos.js): son los que reciben la
   publicidad, así que la prueba social sirve ahí y no repartida al azar.
   `foto` describe la imagen que hay que crear para esa tarjeta. El detalle
   largo de cada foto está en la nota "🖼️ Fotos de las opiniones".
   ---------------------------------------------------------------------- */
const RESENAS = [
  /* `prod` NO se muestra en la tarjeta (Jacsson, 2026-09-20: "en las opiniones no
     deben aparecer los productos"). Queda guardado aquí porque es el producto que
     tiene que salir en la foto de esa opinión: es el dato que Jacsson necesita
     cuando llegue el momento de crear las imágenes. La lista completa, con qué
     debe mostrar cada foto, está en la nota "🖼️ Fotos de las opiniones".

     El oficio va DENTRO del texto, no en una línea aparte: una persona no se
     presenta con una etiqueta debajo del nombre, lo cuenta al hablar. */
  { prod: 125749, nombre: 'Marta V.', meta: '61 · Rancagua', foto: 'resena-marta',
    texto: 'Cuido mi jardín todos los días y me costaba agacharme. Llevo dos frascos y ya es parte de la mañana.' },
  { prod: 103967, nombre: 'Javiera T.', meta: '29 · Valparaíso', foto: 'resena-javiera',
    texto: 'Trabajo en turnos de noche y me costaba cortar el día. Lo tomo un rato antes de acostarme y me ordenó la rutina.' },
  { prod: 84659, nombre: 'Paulina R.', meta: '42 · Temuco', foto: 'resena-paulina',
    texto: 'Soy peluquera y había probado colágeno en polvo, pero lo dejaba botado. En cápsula sí lo mantengo: no hay que medir nada.' },
  { prod: 126340, nombre: 'Ignacio F.', meta: '36 · Valdivia', foto: 'resena-ignacio',
    texto: 'Paso el día en la oficina y voy al gimnasio al salir. Pedí el pack de dos, llegó en un solo paquete y pagué al recibir.' },
  { prod: 54685, nombre: 'Óscar L.', meta: '55 · Antofagasta', foto: 'resena-oscar',
    texto: 'Hago turnos y paso fuera de la casa, así que quería algo simple de seguir. Una cápsula al día y no tengo que pensarlo.' },
  { prod: 72697, nombre: 'Marcela S.', meta: '46 · Copiapó', foto: 'resena-marcela',
    texto: 'Soy mamá de dos y trabajo desde la casa. Me gustó poder leer la etiqueta completa antes de comprar: con lo que uno toma, quiero saber qué trae.' },
  { prod: 96544, nombre: 'Héctor P.', meta: '53 · Talca', foto: 'resena-hector',
    texto: 'Soy camionero y paro poco en la casa, así que mandarlo a la dirección del trabajo me sirvió. Llegó a los dos días.' },
  { prod: 125747, nombre: 'Cristián A.', meta: '49 · Maipú', foto: 'resena-cristian',
    texto: 'Volví al gimnasio a los 49, después de años parado. Escribí antes de pedir y me contestaron las dudas el mismo día.' },
];

/* [2026-10-03] OPINIONES PROPIAS DE CADA PRODUCTO. Jacsson: *"tenemos que crear los
   testimonios de las personas que usan cada producto. Por separado"*. Si la ficha
   tiene opiniones propias, el carrusel de debajo de la foto muestra esas y no las
   8 de la portada. Empieza Hallprost (65555).
   ⚠️ TAMBIÉN SON EJEMPLOS, igual que RESENAS: llevan el letrero "Ejemplo" y no
   prometen resultados (nada de "ya no me levanto en la noche"), solo la
   experiencia de compra y de rutina. `foto: null` = la foto aún no existe: la
   tarjeta sale sin foto hasta que Jacsson la cree (prompts en la nota
   "🖼️ Fotos de las opiniones", sección Hallprost). Al tenerla, dejarla en
   ${AS_A}img-clientes-<nombre>.webp y poner ese nombre en `foto`. */
const RESENAS_PRODUCTO = {
  65555: [
    { nombre: 'Jorge M.', meta: '58 · Puente Alto', foto: null,
      texto: 'Mi señora me lo pidió con el 2x1: uno para mí y otro para mi hermano. Se lo pasé el domingo en el asado y ahora él me pregunta cuándo pedimos otra vez.' },
    { nombre: 'Luis A.', meta: '64 · Chillán', foto: 'resena-hp-luis', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Soy taxista jubilado y no me gusta tomar pastillas que no entiendo. Esta dice pepa de calabaza y zinc, nada más. Eso me convenció.' },
    { nombre: 'Rodrigo P.', meta: '47 · La Florida', foto: 'resena-hp-rodrigo', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'El doctor me dijo que desde los 45 hay que ir al control todos los años. Fui, y además sumé esto en la mañana con el café. Una cápsula y listo.' },
    { nombre: 'Camila S.', meta: '33 · Viña del Mar', foto: null,
      texto: 'Se lo compré a mi papá porque él solo nunca se compra nada. Llegó a su casa, lo pagó él al recibir y me mandó foto del frasco.' },
    { nombre: 'Patricio G.', meta: '52 · Concepción', foto: null,
      texto: 'Trabajo en faena 7x7. Lo pedí un lunes, llegó el miércoles a la casa y mi señora lo recibió. Me duró justo los dos turnos.' },
    { nombre: 'Hernán V.', meta: '69 · Talca', foto: null,
      texto: 'Antes comía pepas de zapallo tostadas, pero se me olvidaba. Con la cápsula no tengo que acordarme de nada: está al lado del cepillo de dientes.' },
  ],  /* [2026-10-04] Los 7 productos de los banners y promocionales, 5 cada uno.
     Mismas reglas: ejemplos, sin prometer resultados. El nombre de archivo de
     cada foto va comentado al lado. Prompts: nota "🖼️ Fotos de las opiniones" → 6️⃣. */
  158579: [   // Drenaje linfático Aurelys (gotas)
    { nombre: 'Carolina R.', meta: '44 · Ñuñoa', foto: 'resena-dr-carolina', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Trabajo de pie todo el día en una farmacia y llego con las piernas cansadas. Me gustó que fueran gotas: las echo en el agua de la tarde y no tengo que tragar nada.' },
    { nombre: 'Verónica T.', meta: '52 · Rancagua', foto: null,   // foto: 'resena-dr-veronica'
      texto: 'Leí la etiqueta antes de pedir: diente de león, ortiga, jengibre… plantas que conozco. Con el 2x1 le pasé un frasco a mi hermana.' },
    { nombre: 'Daniela P.', meta: '38 · Antofagasta', foto: null,   // foto: 'resena-dr-daniela'
      texto: 'Paso horas sentada en la oficina. Lo sumé a mi rutina de la tarde con un vaso de agua grande. El frasco es chico y lo llevo en la cartera.' },
    { nombre: 'Gloria M.', meta: '61 · Temuco', foto: 'resena-dr-gloria', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Mi hija me lo pidió por internet y yo pagué cuando llegó. Me dio confianza no tener que pagar antes.' },
    { nombre: 'Fernanda C.', meta: '29 · Maipú', foto: null,   // foto: 'resena-dr-fernanda'
      texto: 'Trabajo en un call center, ocho horas sentada. Me lo recomendó una compañera, lo pedí ese mismo día y llegó en dos días.' },
  ],
  83439: [   // Gomitas de shilajit
    { nombre: 'Sebastián R.', meta: '41 · Las Condes', foto: 'resena-sh-sebastian', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Odio tragar cápsulas. Las gomitas son lo único que he mantenido más de una semana: las tomo después del almuerzo.' },
    { nombre: 'Mauricio L.', meta: '48 · Quilicura', foto: 'resena-sh-mauricio', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Manejo un camión de reparto y no tengo horario fijo. El frasco va en la guantera y así no se me olvida.' },
    { nombre: 'Andrés F.', meta: '36 · Valparaíso', foto: null,   // foto: 'resena-sh-andres'
      texto: 'Había visto el shilajit en TikTok, pero todo venía de afuera y caro. Acá lo pedí con el 2x1 y pagué al recibir.' },
    { nombre: 'Gonzalo B.', meta: '53 · Puerto Montt', foto: null,   // foto: 'resena-sh-gonzalo'
      texto: 'Mi señora compró con la oferta: un frasco para mí y otro para mi cuñado. Saben bien, nada que ver con un remedio.' },
    { nombre: 'Felipe A.', meta: '44 · San Bernardo', foto: 'resena-sh-felipe', // [anterior: Codex, 2026-10-04] foto: null
      texto: 'Las tengo en el escritorio de la bodega, al lado del termo. Es lo más fácil de recordar que he probado.' },
  ],
  67632: [   // Cúrcuma (Turmeric Curcumin)
    { nombre: 'Ana María S.', meta: '63 · Viña del Mar', foto: 'resena-cu-anamaria', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Tomaba cúrcuma en polvo en la leche, pero manchaba todo. En cápsula es más limpio, y trae pimienta negra, que es como leí que se tiene que tomar.' },
    { nombre: 'Ricardo V.', meta: '58 · La Serena', foto: null,   // foto: 'resena-cu-ricardo'
      texto: 'Juego tenis los sábados con amigos. Uno la tomaba y le pedí el dato. Con el 2x1 compramos un frasco cada uno.' },
    { nombre: 'Isabel N.', meta: '67 · Osorno', foto: 'resena-cu-isabel', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Me gusta leer bien lo que tomo. La etiqueta dice 95% curcuminoides y jengibre, y eso era lo que buscaba.' },
    { nombre: 'Manuel C.', meta: '55 · Iquique', foto: null,   // foto: 'resena-cu-manuel'
      texto: 'Trabajo en construcción hace 30 años. Mi hija me la regaló la primera vez y ahora la pido yo mismo.' },
    { nombre: 'Rosa E.', meta: '60 · Curicó', foto: null,   // foto: 'resena-cu-rosa'
      texto: 'La pedí un lunes y el miércoles estaba en mi casa. Le pagué al repartidor ahí mismo.' },
  ],
  35868: [   // 15 Day Cleanse
    { nombre: 'Javiera M.', meta: '34 · Providencia', foto: 'resena-cl-javiera', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Después de las fiestas patrias quise ordenar mi alimentación y lo sumé a eso. Son hierbas que conozco, como manzanilla y anís.' },
    { nombre: 'Claudia H.', meta: '46 · Concepción', foto: null,   // foto: 'resena-cl-claudia'
      texto: 'Trabajo de noche en un supermercado y como a cualquier hora. Me gusta que sea una rutina corta y clara, de 15 días.' },
    { nombre: 'Pablo R.', meta: '39 · Ñuñoa', foto: null,   // foto: 'resena-cl-pablo'
      texto: 'Mi polola y yo lo pedimos con el 2x1, uno para cada uno. Es más fácil hacerlo de a dos.' },
    { nombre: 'Teresa A.', meta: '57 · Chillán', foto: 'resena-cl-teresa', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Tomo agüita de manzanilla desde chica, así que me dio confianza ver que la trae.' },
    { nombre: 'Nicolás G.', meta: '31 · Rancagua', foto: null,   // foto: 'resena-cl-nicolas'
      texto: 'Lo pedí por el envío gratis y porque se paga al recibir. Llegó en dos días y con la etiqueta en español.' },
  ],
  126340: [   // Magnesio 12 en 1
    { nombre: 'Patricia L.', meta: '49 · La Reina', foto: 'resena-mg-patricia', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Me despertaba de madrugada pensando en todo lo que tenía que hacer. Ahora tengo mi rutina de noche: té, una cápsula y el celular lejos.' },
    { nombre: 'Marcelo D.', meta: '45 · Peñalolén', foto: 'resena-mg-marcelo', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'No sabía qué magnesio comprar: citrato, bisglicinato… Este trae seis tipos y me ahorré tener que elegir.' },
    { nombre: 'Lorena B.', meta: '53 · Talcahuano', foto: null,   // foto: 'resena-mg-lorena'
      texto: 'Soy contadora y trabajo hasta tarde. Lo dejo en el velador para no olvidarlo.' },
    { nombre: 'Cecilia O.', meta: '58 · Valdivia', foto: null,   // foto: 'resena-mg-cecilia'
      texto: 'Lo compré con el 2x1 junto a mi marido. Cada uno tiene su frasco en su velador.' },
    { nombre: 'Tomás H.', meta: '37 · Santiago Centro', foto: null,   // foto: 'resena-mg-tomas'
      texto: 'Trabajo en turnos rotativos. Lo pedí, pagué al recibir y llegó en 48 horas.' },
  ],
  64268: [   // Creatina para mujer
    { nombre: 'Macarena V.', meta: '42 · Lo Barnechea', foto: 'resena-cr-macarena', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Empecé pesas a los 40 con una entrenadora y me recomendó creatina. Esta no tiene sabor: la echo al jugo de la mañana.' },
    { nombre: 'Soledad P.', meta: '48 · Coquimbo', foto: null,   // foto: 'resena-cr-soledad'
      texto: 'Pensaba que la creatina era para hombres musculosos. Vi que hay una pensada para mujeres y me animé.' },
    { nombre: 'Bárbara K.', meta: '39 · Puente Alto', foto: 'resena-cr-barbara', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Tengo dos niños chicos y entreno en la casa con mancuernas. Una medida al día y listo, no tengo que pensar.' },
    { nombre: 'Ximena R.', meta: '55 · Valparaíso', foto: null,   // foto: 'resena-cr-ximena'
      texto: 'Camino y hago pilates. Con el 2x1 compartí con mi amiga del pilates.' },
    { nombre: 'Francisca T.', meta: '33 · Temuco', foto: null,   // foto: 'resena-cr-francisca'
      texto: 'Me gustó que no tuviera azúcar añadida. La mezclo con agua y no sabe a nada.' },
  ],
  84659: [   // Colágeno en péptidos
    { nombre: 'Constanza G.', meta: '37 · Ñuñoa', foto: 'resena-co-constanza', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Probé colágeno en polvo y me aburrí de batirlo. En cápsula me lo tomo con el café y ya.' },
    { nombre: 'Mónica F.', meta: '51 · Viña del Mar', foto: null,   // foto: 'resena-co-monica'
      texto: 'Soy manicurista y mis clientas me preguntan qué tomo. Les digo: cápsulas, llega a la casa y se paga al recibir.' },
    { nombre: 'Andrea S.', meta: '45 · Maipú', foto: 'resena-co-andrea', // [anterior: Claude Code, 2026-10-04] foto: null
      texto: 'Lo llevo en la cartera porque almuerzo en la oficina. Es lo más fácil de mantener que he probado.' },
    { nombre: 'Elena Q.', meta: '62 · San Felipe', foto: null,   // foto: 'resena-co-elena'
      texto: 'Mi nieta lo pidió por internet y yo lo pagué cuando llegó. Así sí me animo a comprar.' },
    { nombre: 'Josefa N.', meta: '28 · Concepción', foto: null,   // foto: 'resena-co-josefa'
      texto: 'Con el 2x1 nos dividimos dos frascos con mi mamá. Una cápsula al día cada una.' },
  ],
  /* [2026-10-04] Los 36 productos restantes del catálogo, 4 opiniones cada uno
     (con 4 la cinta ya se ve llena). Mismas reglas: ejemplos, sin prometer
     resultados, sin médicos, sin afirmar nada del empaque ni de la boleta.
     Prompts: nota "🖼️ Fotos de las opiniones" → 7️⃣. */
  125747: [   // NAD+ para hombres (Selerb)
    { nombre: 'Esteban R.', meta: '46 · Ñuñoa', foto: null,   // foto: 'resena-nad-esteban'
      texto: 'Volví a correr los domingos y quería algo simple para la mañana. Una cápsula con el desayuno y no pienso más en eso.' },
    { nombre: 'Raúl M.', meta: '52 · Talca', foto: null,   // foto: 'resena-nad-raul'
      texto: 'Mi hijo me lo pidió con el descuento y me lo mandó a la casa. Lo pagué yo al recibir, así quedamos a mano.' },
    { nombre: 'Cristóbal V.', meta: '39 · Las Condes', foto: null,   // foto: 'resena-nad-cristobal'
      texto: 'Leí bien la etiqueta: NAD+, resveratrol y cúrcuma en una cápsula. Prefiero eso a tener tres frascos.' },
    { nombre: 'Alejandro P.', meta: '58 · Puerto Varas', foto: null,   // foto: 'resena-nad-alejandro'
      texto: 'Trabajo en turismo y en temporada no paro. El frasco va en la mochila y me acompaña todo el día.' },
  ],
  63663: [   // Óxido nítrico 1000 mg
    { nombre: 'Matías L.', meta: '28 · Maipú', foto: null,   // foto: 'resena-on-matias'
      texto: 'Entreno pesas cuatro veces a la semana. Lo tengo en el bolso del gimnasio, al lado de la botella.' },
    { nombre: 'Diego S.', meta: '35 · Antofagasta', foto: null,   // foto: 'resena-on-diego'
      texto: 'Lo pedí un domingo en la noche y el miércoles estaba en la casa. Llegó bien sellado.' },
    { nombre: 'Joaquín A.', meta: '31 · Valparaíso', foto: null,   // foto: 'resena-on-joaquin'
      texto: 'Con mi compañero de gimnasio aprovechamos el 2x1 y nos dividimos los frascos.' },
    { nombre: 'Ignacio T.', meta: '42 · Concepción', foto: null,   // foto: 'resena-on-ignaciot'
      texto: 'Volví al gimnasio después de años. Me gustó que la etiqueta dijera claro cuánto trae cada cápsula.' },
  ],
  48056: [   // Creatina monohidratada 300 g
    { nombre: 'Benjamín C.', meta: '25 · La Florida', foto: null,   // foto: 'resena-cm-benjamin'
      texto: 'Llevaba tiempo buscando creatina sin sabor para echarla al batido. Esta se disuelve bien y no deja grumos.' },
    { nombre: 'Carla M.', meta: '34 · Viña del Mar', foto: null,   // foto: 'resena-cm-carla'
      texto: 'Entreno fuerza tres veces por semana. El pote me dura dos meses y lo tengo en la cocina, a la vista.' },
    { nombre: 'Rodolfo B.', meta: '47 · Rancagua', foto: null,   // foto: 'resena-cm-rodolfo'
      texto: 'Mi hijo me convenció de entrenar con él. Compramos un pote cada uno con el 2x1.' },
    { nombre: 'Vicente O.', meta: '30 · Temuco', foto: null,   // foto: 'resena-cm-vicente'
      texto: 'Me gustó que dijera micronizada y 5 g por servicio. Fácil de medir.' },
  ],
  91096: [   // Turkesterona (Old School)
    { nombre: 'Leonardo F.', meta: '38 · Peñalolén', foto: null,   // foto: 'resena-tk-leonardo'
      texto: 'Entreno en la casa con un rack que armé en el patio. Las cápsulas las tengo en la repisa de las pesas.' },
    { nombre: 'Hugo G.', meta: '50 · Los Ángeles', foto: null,   // foto: 'resena-tk-hugo'
      texto: 'A los 50 me puse a entrenar en serio. Mi entrenador me habló de la turkesterona y la pedí acá porque se paga al recibir.' },
    { nombre: 'Martín E.', meta: '33 · Santiago Centro', foto: null,   // foto: 'resena-tk-martin'
      texto: 'Lo compartí con un amigo del box con el 2x1. Cada uno tiene su frasco en el locker.' },
    { nombre: 'Renato P.', meta: '44 · Iquique', foto: null,   // foto: 'resena-tk-renato'
      texto: 'Me demoré en decidirme, escribí con dudas y me respondieron el mismo día.' },
  ],
  49208: [   // Curvy Gummies
    { nombre: 'Antonella R.', meta: '27 · Puente Alto', foto: null,   // foto: 'resena-cg-antonella'
      texto: 'Las cápsulas se me olvidaban siempre. Las gomitas las tengo en el velador y me acuerdo sola.' },
    { nombre: 'Katherine S.', meta: '32 · Concepción', foto: null,   // foto: 'resena-cg-katherine'
      texto: 'Con mi hermana aprovechamos el 2x1. Saben a fruta, nada que ver con un suplemento.' },
    { nombre: 'Yasna M.', meta: '40 · La Pintana', foto: null,   // foto: 'resena-cg-yasna'
      texto: 'Pagué cuando llegó, sin dar la tarjeta por internet. Eso me dio confianza para volver a pedir.' },
    { nombre: 'Dayana C.', meta: '24 · Antofagasta', foto: null,   // foto: 'resena-cg-dayana'
      texto: 'Me gusta que traigan probióticos y prebióticos en la misma gomita. Leí la etiqueta completa antes de pedir.' },
  ],
  23482: [   // Menopax Plus
    { nombre: 'Mirta G.', meta: '52 · San Miguel', foto: null,   // foto: 'resena-mp-mirta'
      texto: 'Busqué algo con hierbas para esta etapa. Salvia, alfalfa y manzanilla: todo lo conozco de toda la vida.' },
    { nombre: 'Silvia R.', meta: '55 · Valparaíso', foto: null,   // foto: 'resena-mp-silvia'
      texto: 'Mis amigas del grupo de caminata me preguntaron qué tomaba. Ahora pedimos juntas para aprovechar el envío gratis.' },
    { nombre: 'Inés V.', meta: '49 · Temuco', foto: null,   // foto: 'resena-mp-ines'
      texto: 'Me gustó que se pudiera pagar al recibir. No me gusta poner la tarjeta en páginas que no conozco.' },
    { nombre: 'Carmen L.', meta: '57 · Arica', foto: null,   // foto: 'resena-mp-carmen'
      texto: 'Lo tomo en la mañana con el desayuno. Es una rutina corta y no tengo que acordarme de nada más.' },
  ],
  64269: [   // Probiótico íntimo femenino
    { nombre: 'Natalia F.', meta: '31 · Providencia', foto: null,   // foto: 'resena-pi-natalia'
      texto: 'Me daba vergüenza preguntar en la farmacia. Acá leí la etiqueta tranquila y lo pedí desde la casa.' },
    { nombre: 'Paola E.', meta: '38 · Quilpué', foto: null,   // foto: 'resena-pi-paola'
      texto: 'Me gustó que fuera vegano y con inulina. Una cápsula al día con el desayuno.' },
    { nombre: 'Marisol A.', meta: '45 · Talca', foto: null,   // foto: 'resena-pi-marisol'
      texto: 'Una amiga me habló de sumar probióticos a la rutina. Este lo encontré acá con envío gratis.' },
    { nombre: 'Tamara B.', meta: '27 · Puerto Montt', foto: null,   // foto: 'resena-pi-tamara'
      texto: 'Con el descuento me salió bien de precio. Lo pagué con tarjeta cuando llegó.' },
  ],
  103967: [   // Sleep Zen
    { nombre: 'Gabriela T.', meta: '41 · Ñuñoa', foto: null,   // foto: 'resena-sz-gabriela'
      texto: 'Mi rutina de noche ahora es: ducha, té, una medida y celular lejos. Me ordenó los horarios.' },
    { nombre: 'Juan Pablo R.', meta: '50 · Maipú', foto: null,   // foto: 'resena-sz-juanpablo'
      texto: 'Trabajo de guardia con turnos cambiados. Me gustó leer que trae magnesio, zinc y vitaminas.' },
    { nombre: 'Rocío M.', meta: '35 · Viña del Mar', foto: null,   // foto: 'resena-sz-rocio'
      texto: 'Lo compré para mí y para mi mamá con el 2x1. Cada una lo tiene en su velador.' },
    { nombre: 'Álvaro N.', meta: '44 · La Serena', foto: null,   // foto: 'resena-sz-alvaro'
      texto: 'Pedí, pagué al recibir y llegó en dos días. Así de simple.' },
  ],
  54979: [   // Ashwagandha + magnesio
    { nombre: 'Fabiola C.', meta: '39 · Las Condes', foto: null,   // foto: 'resena-am-fabiola'
      texto: 'Antes tomaba ashwagandha y magnesio por separado. Ahora es un solo frasco y me ahorro uno.' },
    { nombre: 'Germán P.', meta: '46 · Concepción', foto: null,   // foto: 'resena-am-german'
      texto: 'Soy profesor de colegio y llego cansado de la pega. Lo tomo cuando llego a la casa, con agua.' },
    { nombre: 'Lucía H.', meta: '33 · Valdivia', foto: null,   // foto: 'resena-am-lucia'
      texto: 'Me gustó ver en la etiqueta que trae bisglicinato y citrato. Era lo que andaba buscando.' },
    { nombre: 'Ramón V.', meta: '55 · Copiapó', foto: null,   // foto: 'resena-am-ramon'
      texto: 'Lo pedí con el 2x1 para mí y mi señora. Nos llegó un solo paquete.' },
  ],
  96342: [   // MagneCalm Pro
    { nombre: 'Daniel I.', meta: '37 · Providencia', foto: null,   // foto: 'resena-mc-daniel'
      texto: 'Buscaba magnesio bisglicinato y este además trae B6 y D3. Una cápsula y listo.' },
    { nombre: 'Marta Elena S.', meta: '60 · Chillán', foto: null,   // foto: 'resena-mc-martaelena'
      texto: 'Mi nuera me lo recomendó. Lo tomo con la once y ya es costumbre.' },
    { nombre: 'Cristina P.', meta: '43 · Rancagua', foto: null,   // foto: 'resena-mc-cristina'
      texto: 'Me gustó que la etiqueta fuera clara. Escribí para preguntar la dosis y me contestaron rápido.' },
    { nombre: 'Pedro J.', meta: '49 · Antofagasta', foto: null,   // foto: 'resena-mc-pedro'
      texto: 'Trabajo en minería 4x4. Lo llevo en el bolso de faena junto con mis cosas.' },
  ],
  91095: [   // Rest Sleep Drops
    { nombre: 'Victoria A.', meta: '36 · Ñuñoa', foto: null,   // foto: 'resena-rs-victoria'
      texto: 'Prefiero las gotas a las pastillas. Las echo en una agüita de hierbas antes de acostarme.' },
    { nombre: 'Sergio M.', meta: '58 · Talca', foto: null,   // foto: 'resena-rs-sergio'
      texto: 'Mi señora lo pidió para los dos con el 2x1. El frasco dura harto.' },
    { nombre: 'Emilia R.', meta: '29 · Valparaíso', foto: null,   // foto: 'resena-rs-emilia'
      texto: 'Me gustó leer que trae valeriana y tila, que son cosas que conozco. Llegó en dos días.' },
    { nombre: 'Héctor L.', meta: '64 · Los Andes', foto: null,   // foto: 'resena-rs-hectorl'
      texto: 'Lo pagué al recibir. A mi edad no me gusta comprar sin ver lo que llega.' },
  ],
  61032: [   // Ashwagandha 1000 mg
    { nombre: 'Josefina D.', meta: '30 · Providencia', foto: null,   // foto: 'resena-as-josefina'
      texto: 'Quería ashwagandha sola, sin mezclas. Esta es eso y trae B12.' },
    { nombre: 'Nelson B.', meta: '48 · Puente Alto', foto: null,   // foto: 'resena-as-nelson'
      texto: 'Soy chofer de micro y mi día es largo. Lo tomo antes de salir, a las 5 de la mañana.' },
    { nombre: 'Paulina V.', meta: '41 · Viña del Mar', foto: null,   // foto: 'resena-as-paulinav'
      texto: 'Con el 2x1 le regalé uno a mi hermana. Nos llegó todo en un paquete.' },
    { nombre: 'Ricardo A.', meta: '36 · Temuco', foto: null,   // foto: 'resena-as-ricardoa'
      texto: 'Lo vi en un video y lo busqué en Chile. Acá lo encontré con envío gratis y pago al recibir.' },
  ],
  95120: [   // Lemme Burn
    { nombre: 'Scarlett M.', meta: '28 · La Florida', foto: null,   // foto: 'resena-lb-scarlett'
      texto: 'Lo sumé a mi rutina junto con caminar todos los días. Me gustó que trajera té verde y complejo B.' },
    { nombre: 'Viviana C.', meta: '42 · Concepción', foto: null,   // foto: 'resena-lb-viviana'
      texto: 'Con mi compañera de pega lo compramos con el 2x1. Nos acompañamos con la rutina.' },
    { nombre: 'Denisse R.', meta: '35 · Arica', foto: null,   // foto: 'resena-lb-denisse'
      texto: 'Leí la etiqueta completa antes de pedir. Llegó rápido hasta Arica, y sin pagar envío.' },
    { nombre: 'Loreto P.', meta: '47 · Maipú', foto: null,   // foto: 'resena-lb-loreto'
      texto: 'Me gustó pagar cuando llegó. Así uno compra tranquila.' },
  ],
  91660: [   // Gomitas de vinagre de manzana
    { nombre: 'Camila R.', meta: '26 · Ñuñoa', foto: null,   // foto: 'resena-vm-camilar'
      texto: 'Intenté tomar vinagre de manzana en agua y no pude con el sabor. Las gomitas saben a manzana y ya.' },
    { nombre: 'Patricia M.', meta: '50 · Viña del Mar', foto: null,   // foto: 'resena-vm-patriciam'
      texto: 'Me gustó que fueran veganas, sin gluten y sin azúcar. Lo revisé en la etiqueta.' },
    { nombre: 'Karen L.', meta: '33 · Puerto Montt', foto: null,   // foto: 'resena-vm-karen'
      texto: 'Con mi pareja las compramos con el 2x1. Cada uno las tiene en su escritorio.' },
    { nombre: 'Iván S.', meta: '40 · Rancagua', foto: null,   // foto: 'resena-vm-ivan'
      texto: 'Las pedí un lunes y llegaron el miércoles. Pagué al recibir.' },
  ],
  125745: [   // Berberina
    { nombre: 'Alicia F.', meta: '54 · La Reina', foto: null,   // foto: 'resena-bb-alicia'
      texto: 'Buscaba berberina sola, sin mezclas. La etiqueta dice 500 mg y nada más, como la quería.' },
    { nombre: 'Francisco N.', meta: '47 · Concepción', foto: null,   // foto: 'resena-bb-francisco'
      texto: 'Lo tomo con el almuerzo. Lo dejé en el cajón del escritorio de la pega.' },
    { nombre: 'Angélica R.', meta: '58 · Curicó', foto: null,   // foto: 'resena-bb-angelica'
      texto: 'Mi hija me lo pidió por internet. Pagué cuando llegó, sin tarjeta por internet.' },
    { nombre: 'Mario T.', meta: '62 · Valparaíso', foto: null,   // foto: 'resena-bb-mario'
      texto: 'Compré dos con el 2x1, uno para mí y otro para mi hermano. Llegaron en un solo paquete.' },
  ],
  72945: [   // Balloon Slim
    { nombre: 'Bárbara O.', meta: '36 · Maipú', foto: null,   // foto: 'resena-bs-barbarao'
      texto: 'Lo sumé a mi rutina de alimentación. Me gustó que fuera fácil de llevar en la cartera.' },
    { nombre: 'Marcela D.', meta: '44 · Temuco', foto: null,   // foto: 'resena-bs-marcelad'
      texto: 'Lo pedí con el descuento y pagué al recibir. Llegó en tres días hasta Temuco.' },
    { nombre: 'Valeska S.', meta: '31 · La Serena', foto: null,   // foto: 'resena-bs-valeska'
      texto: 'Escribí para preguntar cómo se toma y me respondieron el mismo día, con calma.' },
    { nombre: 'Ruth A.', meta: '52 · Puente Alto', foto: null,   // foto: 'resena-bs-ruth'
      texto: 'Mi hija y yo lo compramos juntas para hacer la rutina de a dos.' },
  ],
  58061: [   // Tripack NAD + ashwagandha + cándida
    { nombre: 'Eduardo S.', meta: '49 · Las Condes', foto: null,   // foto: 'resena-tp-eduardo'
      texto: 'Quería los tres y me llegaron juntos en un solo envío. Me ahorré hacer tres pedidos.' },
    { nombre: 'Claudia M.', meta: '45 · Viña del Mar', foto: null,   // foto: 'resena-tp-claudiam'
      texto: 'Me gusta tener todo ordenado en la repisa: los tres frascos juntos y sé qué tomar en la mañana.' },
    { nombre: 'Rolando P.', meta: '57 · Rancagua', foto: null,   // foto: 'resena-tp-rolando'
      texto: 'Pagué al recibir, que era lo que me importaba. Llegó todo bien.' },
    { nombre: 'Verónica A.', meta: '50 · Concepción', foto: null,   // foto: 'resena-tp-veronicaa'
      texto: 'Leí cada etiqueta antes de pedir. Me gustó que fueran productos que se pueden revisar uno por uno.' },
  ],
  87268: [   // Pack x3 NAD+ resveratrol
    { nombre: 'Guillermo R.', meta: '55 · Providencia', foto: null,   // foto: 'resena-px-guillermo'
      texto: 'Ya lo tomaba y quería dejarlo resuelto por varios meses. Con el pack de tres no me preocupo.' },
    { nombre: 'Ana Luisa P.', meta: '60 · Viña del Mar', foto: null,   // foto: 'resena-px-analuisa'
      texto: 'Lo compartimos con mi marido. Tres frascos nos duran harto tiempo.' },
    { nombre: 'Rubén C.', meta: '52 · Temuco', foto: null,   // foto: 'resena-px-ruben'
      texto: 'Me salió más conveniente que comprar de a uno. Llegó en un solo paquete.' },
    { nombre: 'Fernando L.', meta: '48 · Antofagasta', foto: null,   // foto: 'resena-px-fernando'
      texto: 'Pagué al recibir y el repartidor fue muy amable. Todo bien sellado.' },
  ],
  54685: [   // NAD Life Extension
    { nombre: 'Alberto G.', meta: '53 · La Reina', foto: null,   // foto: 'resena-nl-alberto'
      texto: 'Me gustó que el NAD+ y el resveratrol vinieran en el mismo frasco. Una cápsula y ya.' },
    { nombre: 'Sandra V.', meta: '47 · Concepción', foto: null,   // foto: 'resena-nl-sandra'
      texto: 'Trabajo hasta tarde y quería algo fácil de mantener. Lo dejo al lado del cepillo de dientes.' },
    { nombre: 'Óscar M.', meta: '58 · San Bernardo', foto: null,   // foto: 'resena-nl-oscarm'
      texto: 'Mi hija lo pidió por mí. Yo pagué cuando llegó.' },
    { nombre: 'Patricio L.', meta: '45 · Puerto Montt', foto: null,   // foto: 'resena-nl-patriciol'
      texto: 'Llegó en tres días hasta Puerto Montt y sin pagar envío. Eso no lo encuentro fácil.' },
  ],
  46242: [   // Resveratrol 590 mg
    { nombre: 'Mariana T.', meta: '44 · Vitacura', foto: null,   // foto: 'resena-rv-mariana'
      texto: 'Quería resveratrol sin mezclas. Este trae extracto de vino tinto, pepa de uva y arándano.' },
    { nombre: 'Jaime O.', meta: '59 · Talca', foto: null,   // foto: 'resena-rv-jaime'
      texto: 'Soy de campo y no compro mucho por internet. Me animé porque se paga al recibir.' },
    { nombre: 'Teresita B.', meta: '52 · Viña del Mar', foto: null,   // foto: 'resena-rv-teresita'
      texto: 'Con el 2x1 compré para mí y para una amiga. Nos llegó en un solo paquete.' },
    { nombre: 'Gustavo E.', meta: '41 · Ñuñoa', foto: null,   // foto: 'resena-rv-gustavo'
      texto: 'Lo tomo en el desayuno. Es lo más simple de mi rutina.' },
  ],
  72697: [   // Liver Complex
    { nombre: 'Roberto F.', meta: '56 · Maipú', foto: null,   // foto: 'resena-lc-roberto'
      texto: 'Lo sumé a mi rutina de la mañana. Me gustó leer que trae selenio y L-cisteína.' },
    { nombre: 'Ximena L.', meta: '49 · Concepción', foto: null,   // foto: 'resena-lc-ximenal'
      texto: 'Mi marido y yo lo compramos con el descuento. Cada uno tiene el suyo.' },
    { nombre: 'Hernán P.', meta: '61 · La Serena', foto: null,   // foto: 'resena-lc-hernanp'
      texto: 'Pagué cuando llegó y vino bien sellado. Así me gusta comprar.' },
    { nombre: 'Isabel C.', meta: '45 · Puerto Montt', foto: null,   // foto: 'resena-lc-isabelc'
      texto: 'Escribí preguntando y me contestaron el mismo día. Pedí ahí mismo.' },
  ],
  96544: [   // Hepa Health
    { nombre: 'Luis Alberto R.', meta: '60 · Chillán', foto: null,   // foto: 'resena-hh-luisalberto'
      texto: 'Tomo agüita de boldo de toda la vida. Ver boldo y diente de león en la etiqueta me dio confianza.' },
    { nombre: 'Marta R.', meta: '55 · Valparaíso', foto: null,   // foto: 'resena-hh-martar'
      texto: 'Me gusta que sean hierbas conocidas. Lo tomo después de almuerzo.' },
    { nombre: 'Francisco G.', meta: '50 · Rancagua', foto: null,   // foto: 'resena-hh-franciscog'
      texto: 'Lo compramos con mi hermano con el 2x1. Llegó un solo paquete a mi casa.' },
    { nombre: 'Elsa M.', meta: '63 · Temuco', foto: null,   // foto: 'resena-hh-elsa'
      texto: 'Mi nieto me lo pidió por internet. Pagué cuando llegó.' },
  ],
  57201: [   // Limpieza de colon 15 días
    { nombre: 'Constanza R.', meta: '33 · Providencia', foto: null,   // foto: 'resena-lco-constanzar'
      texto: 'Me gustó que fuera una rutina con principio y fin: 15 días y listo.' },
    { nombre: 'Ricardo M.', meta: '45 · Concepción', foto: null,   // foto: 'resena-lco-ricardom'
      texto: 'Lo hice junto a mi señora después de las fiestas. Así nos acompañamos.' },
    { nombre: 'Paula A.', meta: '38 · La Florida', foto: null,   // foto: 'resena-lco-paulaa'
      texto: 'Lo pedí desde el celular en dos minutos y llegó a la casa en tres días.' },
    { nombre: 'Jorge E.', meta: '52 · Valdivia', foto: null,   // foto: 'resena-lco-jorgee'
      texto: 'Lo pagué al recibir. Escribí antes y me explicaron todo.' },
  ],
  37301: [   // Candida Cleanse
    { nombre: 'Antonia S.', meta: '34 · Ñuñoa', foto: null,   // foto: 'resena-cc-antonia'
      texto: 'Leí la etiqueta completa antes de pedir: caprilato y hierbas. Me gustó que fuera claro.' },
    { nombre: 'Margarita L.', meta: '51 · Viña del Mar', foto: null,   // foto: 'resena-cc-margarita'
      texto: 'Lo compré con el descuento del Cyber y llegó rapidísimo.' },
    { nombre: 'Cristián G.', meta: '40 · Maipú', foto: null,   // foto: 'resena-cc-cristiang'
      texto: 'Lo tomo en el desayuno, al lado del café. Fácil de recordar.' },
    { nombre: 'Pía R.', meta: '29 · Temuco', foto: null,   // foto: 'resena-cc-pia'
      texto: 'Pagué al recibir. No me gusta poner la tarjeta en páginas que no conozco.' },
  ],
  50838: [   // Gomitas de fibra Physician's Choice
    { nombre: 'Valentina R.', meta: '32 · Las Condes', foto: null,   // foto: 'resena-gf-valentinar'
      texto: 'Sé que como poca fibra y en polvo no me lo tomaba. Las gomitas sí: frambuesa y limón.' },
    { nombre: 'Marcos A.', meta: '45 · Concepción', foto: null,   // foto: 'resena-gf-marcos'
      texto: 'Mis hijos me ven y también quieren. Saben a dulce, no a suplemento.' },
    { nombre: 'Lidia P.', meta: '58 · Rancagua', foto: null,   // foto: 'resena-gf-lidia'
      texto: 'Me gusta que la etiqueta diga 5 g de fibra por porción. Así sé lo que tomo.' },
    { nombre: 'Tomás R.', meta: '27 · Valparaíso', foto: null,   // foto: 'resena-gf-tomasr'
      texto: 'Las pedí y pagué cuando llegaron. Rápido y sin enredo.' },
  ],
  84072: [   // Aceite de orégano
    { nombre: 'Elisa V.', meta: '47 · Ñuñoa', foto: null,   // foto: 'resena-or-elisa'
      texto: 'Buscaba aceite de orégano orgánico en gotas. Este dice USDA Organic en la etiqueta.' },
    { nombre: 'Raimundo C.', meta: '55 · Talca', foto: null,   // foto: 'resena-or-raimundo'
      texto: 'Mi señora lo usa hace años y lo compraba afuera. Acá llegó en dos días.' },
    { nombre: 'Florencia M.', meta: '31 · Valdivia', foto: null,   // foto: 'resena-or-florencia'
      texto: 'Con el 2x1 compré para mí y para mi mamá. El frasco dura harto.' },
    { nombre: 'Arturo B.', meta: '63 · Viña del Mar', foto: null,   // foto: 'resena-or-arturo'
      texto: 'Pagué al recibir. Así compro tranquilo.' },
  ],
  97448: [   // OsteoRegen
    { nombre: 'Gladys R.', meta: '62 · Ñuñoa', foto: null,   // foto: 'resena-og-gladys'
      texto: 'Quería sumar calcio y vitamina D a mi alimentación. Este trae también K2, lo leí en la etiqueta.' },
    { nombre: 'Humberto S.', meta: '66 · Chillán', foto: null,   // foto: 'resena-og-humberto'
      texto: 'Mi hija me lo pidió. Lo tomo con el desayuno.' },
    { nombre: 'Norma V.', meta: '58 · La Serena', foto: null,   // foto: 'resena-og-norma'
      texto: 'Con mi hermana aprovechamos el 2x1. Hicimos un solo pedido.' },
    { nombre: 'Ernesto L.', meta: '61 · Temuco', foto: null,   // foto: 'resena-og-ernesto'
      texto: 'Pagué al recibir. Llegó en tres días.' },
  ],
  96539: [   // Osteomax
    { nombre: 'Rebeca A.', meta: '56 · Providencia', foto: null,   // foto: 'resena-om-rebeca'
      texto: 'Me gustó tener calcio, magnesio y colágeno en un solo frasco. Uno menos en la repisa.' },
    { nombre: 'Domingo P.', meta: '63 · Rancagua', foto: null,   // foto: 'resena-om-domingo'
      texto: 'Camino todas las mañanas con mi perro. Lo tomo cuando vuelvo.' },
    { nombre: 'Olga M.', meta: '59 · Concepción', foto: null,   // foto: 'resena-om-olga'
      texto: 'Lo compré para mí y mi comadre con el descuento. Llegó rápido.' },
    { nombre: 'Luis F.', meta: '57 · Antofagasta', foto: null,   // foto: 'resena-om-luisf'
      texto: 'Pagué con tarjeta al repartidor. Todo bien.' },
  ],
  125749: [   // Joint Health
    { nombre: 'Juana P.', meta: '58 · Puente Alto', foto: null,   // foto: 'resena-jh-juana'
      texto: 'Trabajo de pie en una feria. Me gustó que trajera magnesio, colágeno, cúrcuma y jengibre en una cápsula.' },
    { nombre: 'Ramiro T.', meta: '50 · Viña del Mar', foto: null,   // foto: 'resena-jh-ramiro'
      texto: 'Juego fútbol los sábados con amigos. Uno lo tomaba y le pedí el dato.' },
    { nombre: 'Carolina S.', meta: '45 · Concepción', foto: null,   // foto: 'resena-jh-carolinas'
      texto: 'Lo compré con el 2x1 para mí y para mi mamá. Una cápsula al día cada una.' },
    { nombre: 'Raúl S.', meta: '62 · Talca', foto: null,   // foto: 'resena-jh-rauls'
      texto: 'Pagué al recibir y llegó en dos días. Muy bien.' },
  ],
  96541: [   // Colágeno + biotina (Golden Prod)
    { nombre: 'Fernanda R.', meta: '35 · Las Condes', foto: null,   // foto: 'resena-cb-fernandar'
      texto: 'Antes compraba colágeno y biotina por separado. Ahora es un solo frasco.' },
    { nombre: 'Jacqueline M.', meta: '48 · Maipú', foto: null,   // foto: 'resena-cb-jacqueline'
      texto: 'Soy peluquera y mis clientas me preguntan qué tomo. Les muestro el frasco.' },
    { nombre: 'Belén A.', meta: '29 · Valparaíso', foto: null,   // foto: 'resena-cb-belen'
      texto: 'Con mi hermana aprovechamos el 2x1. Cada una con su frasco.' },
    { nombre: 'Sonia P.', meta: '56 · Temuco', foto: null,   // foto: 'resena-cb-sonia'
      texto: 'Me lo pidió mi hija y pagué cuando llegó. Así me quedo tranquila.' },
  ],
  63664: [   // Biotina + colágeno 1000 mg
    { nombre: 'Daniela M.', meta: '33 · Ñuñoa', foto: null,   // foto: 'resena-bc-danielam'
      texto: 'Me gustó que además de biotina y colágeno trajera vitaminas A, C, D y E.' },
    { nombre: 'Rosa María L.', meta: '52 · Concepción', foto: null,   // foto: 'resena-bc-rosamaria'
      texto: 'Lo tomo con el desayuno. Es una cápsula y ya.' },
    { nombre: 'Ingrid V.', meta: '41 · Rancagua', foto: null,   // foto: 'resena-bc-ingrid'
      texto: 'Lo compré con el descuento y llegó en dos días.' },
    { nombre: 'Catalina P.', meta: '27 · Valdivia', foto: null,   // foto: 'resena-bc-catalina'
      texto: 'Pagué al recibir. Es la forma en que más me gusta comprar.' },
  ],
  72944: [   // Colageterna
    { nombre: 'Pamela R.', meta: '43 · La Reina', foto: null,   // foto: 'resena-ce-pamela'
      texto: 'Prefiero cápsulas antes que polvo. Viene en su caja y se ve ordenado en el baño.' },
    { nombre: 'Mercedes S.', meta: '57 · Valparaíso', foto: null,   // foto: 'resena-ce-mercedes'
      texto: 'Lo compré para mí y mi hermana con el descuento. Llegó en un solo paquete.' },
    { nombre: 'Gisela M.', meta: '39 · Maipú', foto: null,   // foto: 'resena-ce-gisela'
      texto: 'Lo tomo con el café de la mañana. Fácil de mantener.' },
    { nombre: 'Carmen Gloria T.', meta: '61 · Talca', foto: null,   // foto: 'resena-ce-carmengloria'
      texto: 'Pagué al recibir. A mi edad me da confianza.' },
  ],
  72695: [   // Prostaphytol
    { nombre: 'Arturo M.', meta: '57 · Ñuñoa', foto: null,   // foto: 'resena-pp-arturom'
      texto: 'Fui al control con el urólogo como corresponde y además sumé esto a mi rutina. Me gustó que trajera pepa de calabaza y zinc.' },
    { nombre: 'Héctor R.', meta: '63 · Concepción', foto: null,   // foto: 'resena-pp-hectorr'
      texto: 'Mi señora me lo compró, porque yo nunca me compro nada. Lo tomo con el desayuno.' },
    { nombre: 'Juan Carlos P.', meta: '60 · La Serena', foto: null,   // foto: 'resena-pp-juancarlos'
      texto: 'Pagué al recibir, que es como me gusta comprar. Llegó bien sellado.' },
    { nombre: 'Víctor H.', meta: '55 · Temuco', foto: null,   // foto: 'resena-pp-victor'
      texto: 'Leí la etiqueta completa antes de pedir. Escribí con dudas y me contestaron rápido.' },
  ],
  59438: [   // Melena de león
    { nombre: 'Sofía L.', meta: '30 · Providencia', foto: null,   // foto: 'resena-ml-sofia'
      texto: 'Trabajo frente al computador todo el día. Me gustó que trajera melena de león con magnesio y complejo B.' },
    { nombre: 'Andrés M.', meta: '45 · Concepción', foto: null,   // foto: 'resena-ml-andresm'
      texto: 'Lo vi en un podcast y lo busqué acá. Llegó en tres días.' },
    { nombre: 'Rocío F.', meta: '38 · Viña del Mar', foto: null,   // foto: 'resena-ml-rociof'
      texto: 'Con mi pareja lo compramos con el 2x1. Cada uno en su escritorio.' },
    { nombre: 'Héctor A.', meta: '52 · Rancagua', foto: null,   // foto: 'resena-ml-hectora'
      texto: 'Pagué al recibir y vino bien sellado. Todo correcto.' },
  ],
  72696: [   // AudioCalm
    { nombre: 'Edith M.', meta: '60 · Ñuñoa', foto: null,   // foto: 'resena-ac-edith'
      texto: 'Me gustó que la etiqueta dijera claro qué trae: vitaminas y té verde. Lo tomo en la mañana.' },
    { nombre: 'René P.', meta: '58 · Valparaíso', foto: null,   // foto: 'resena-ac-rene'
      texto: 'Mi hija me lo pidió por internet y yo pagué al recibir.' },
    { nombre: 'Marcela V.', meta: '47 · Concepción', foto: null,   // foto: 'resena-ac-marcelav'
      texto: 'Escribí para preguntar y me respondieron el mismo día, con paciencia.' },
    { nombre: 'Oscar R.', meta: '62 · Talca', foto: null,   // foto: 'resena-ac-oscarr'
      texto: 'Lo compré con el descuento del Cyber. Llegó en dos días.' },
  ],
  89150: [   // Veinophytol Pro
    { nombre: 'Lucía M.', meta: '50 · Maipú', foto: null,   // foto: 'resena-vp-luciam'
      texto: 'Trabajo de pie en una tienda todo el día. Lo sumé a mi rutina de la mañana.' },
    { nombre: 'Soledad R.', meta: '45 · Viña del Mar', foto: null,   // foto: 'resena-vp-soledadr'
      texto: 'Soy secretaria y paso horas sentada. Lo dejo en el escritorio.' },
    { nombre: 'Ana P.', meta: '58 · Rancagua', foto: null,   // foto: 'resena-vp-anap'
      texto: 'Con el descuento compré para mí y mi hermana. Llegó en un solo paquete.' },
    { nombre: 'Myriam L.', meta: '62 · Temuco', foto: null,   // foto: 'resena-vp-myriam'
      texto: 'Pagué al recibir. Llegó rápido hasta Temuco.' },
  ],
};

function reviewCard(r) {
  /* [2026-10-03] Sin foto todavía: tarjeta solo de texto, sin hueco vacío. */
  if (!r.foto) return `<article class="review review-sin-foto">
    <div class="review-body">
      <div class="review-top">${stars()}<span class="review-demo">Ejemplo</span></div>
      <p class="review-text">“${r.texto}”</p>
      <div class="review-meta"><b>${r.nombre}</b><span>${r.meta}</span></div>
    </div>
  </article>`;
  return `<article class="review">
    <!-- [2026-10-03, auditoría] width/height = la medida real de las fotos
         (1200×800): el navegador reserva el espacio antes de que lleguen. -->
    <div class="slot"><img src="${AS_A}img-clientes-${r.foto}.webp" alt="Foto de ${r.nombre} con el producto" width="1200" height="800" loading="lazy" decoding="async"></div>
    <div class="review-body">
      <div class="review-top">${stars()}<span class="review-demo">Ejemplo</span></div>
      <p class="review-text">“${r.texto}”</p>
      <div class="review-meta"><b>${r.nombre}</b><span>${r.meta}</span></div>
    </div>
  </article>`;
}

function reviews() {
  document.querySelectorAll('[data-reviews]').forEach((el) => {
    if (el.querySelector('.marquee-track')) return;
    /* [2026-10-03] data-reviews="<id>" en la ficha: sus opiniones propias si las tiene.
       [anterior: Claude Code] siempre RESENAS */
    const propias = RESENAS_PRODUCTO[el.dataset.reviews];
    /* [2026-10-04, Codex] Las fotos propias van primero en su ficha: es la
       entrada visual de la reseña y las que aún son solo texto quedan después. */
    const ordenadas = propias
      ? [...propias].sort((a, b) => Number(Boolean(b.foto)) - Number(Boolean(a.foto)))
      : RESENAS;
    const cards = ordenadas.map(reviewCard).join('');
    el.innerHTML = `<div class="marquee-track">${cards}${cards}</div>`;
  });
}

/* ---------- contador hacia la fecha real ---------- */
function countdowns() {
  const end = new Date(STORE.offerEnd).getTime();
  const els = document.querySelectorAll('[data-countdown]');
  if (!els.length) return;
  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => {
    const ms = end - Date.now();
    els.forEach((el) => {
      if (ms <= 0) { el.hidden = true; return; }
      const d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
      el.querySelector('.cd').textContent = `${d}d ${pad(h)}h ${pad(m)}m ${pad(s)}s`;
    });
  };
  tick();
  setInterval(tick, 1000);
}

/* ---------- aparición al hacer scroll: lo que ya se ve queda visible ---------- */
function reveal() {
  const items = document.querySelectorAll('[data-rv]');
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('rv-in');
      e.target.classList.remove('rv-wait');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  items.forEach((el) => {
    if (el.getBoundingClientRect().top < innerHeight * 0.92) return;
    [...el.children].forEach((c, i) => c.style.setProperty('--d', `${Math.min(i, 6) * 0.07}s`));
    el.classList.add('rv-wait');
    io.observe(el);
  });
}
/* los hijos de un grupo [data-rv-group] aparecen en cascada */
function revealGroups() {
  document.querySelectorAll('[data-rv-group]').forEach((g) => [...g.children].forEach((c) => c.setAttribute('data-rv', '')));
}

/* ---------- números que suben ---------- */
function countUps() {
  const els = document.querySelectorAll('[data-count]');
  if (!('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      const el = e.target, to = +el.dataset.count, from = +(el.dataset.from || 0), t0 = performance.now(), dur = 1400;
      const step = (t) => {
        const p = Math.min(1, (t - t0) / dur), v = Math.round(from + (to - from) * (1 - Math.pow(1 - p, 3)));
        el.textContent = el.dataset.money ? clp(v) : v;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
      io.unobserve(el);
    });
  }, { threshold: 0.6 });
  els.forEach((el) => io.observe(el));
}

/* ---------- cabecera que se achica ---------- */
function headerScroll() {
  const h = document.querySelector('.site-header');
  if (!h) return;
  const on = () => h.classList.toggle('scrolled', scrollY > 10);
  on();
  addEventListener('scroll', on, { passive: true });
}

/* ---------- aviso ---------- */
function toast(msg) {
  let t = document.querySelector('.toast');
  if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(t._h);
  t._h = setTimeout(() => t.classList.remove('show'), 3200);
}

/* ---------- embajadores (personajes IA de ejemplo, patrón de IM8 / Cymbiotika) ----------
   Hablan del proceso (fácil, llega junto, pagas al recibir), no de resultados. */
/* `prod` es el producto que usa ese personaje. NO sale en la tarjeta: define
   qué frasco tiene que aparecer en la foto que se le cree. El detalle de
   cada foto está en la nota "🖼️ Fotos de las opiniones". */
const PERSONAS = [
  { id: 'rodrigo', posY: '0%', prod: 83439, kit: 'energia', name: 'Rodrigo M.', meta: '47 · Puente Alto', quote: 'Soy papá de tres y juego pichanga los sábados. Lo tomo con el desayuno y ya es parte del día: me llegó todo junto y pagué al recibir.', g: '#2A2418,#0E0E0E' },
  { id: 'carolina', prod: 64268, kit: 'mujer', name: 'Carolina P.', meta: '38 · Viña del Mar', quote: 'Soy contadora y mamá, así que la mañana se me hace corta. La creatina va en el batido, un minuto y listo: por fin algo que sí mantengo.', g: '#8E4A7C,#3A1231' },
  { id: 'felipe', prod: 48056, kit: 'energia', name: 'Felipe S.', meta: '52 · Concepción', quote: 'Salgo en bicicleta los fines de semana. Antes compraba cada frasco en un lado distinto; ahora es un solo pedido y un solo envío.', g: '#3A3222,#141414' },
  { id: 'daniela', prod: 96541, kit: 'mujer', name: 'Daniela R.', meta: '44 · Ñuñoa', quote: 'Soy profesora y me gustó ver la etiqueta real de cada frasco antes de comprar. Nada escondido.', g: '#C47FA2,#6B2D5C' },
  { id: 'valentina', prod: 72944, kit: 'mujer', name: 'Valentina C.', meta: '31 · Santiago', quote: 'Entreno cuatro veces por semana. La creatina sin sabor se mezcla con todo y el colágeno en cápsula, sin medir nada.', g: '#B5708F,#5A2149' },
  { id: 'jorge', prod: 61032, kit: 'energia', name: 'Jorge A.', meta: '58 · La Serena', quote: 'Me jubilé hace poco y quería una rutina simple de seguir, sin estar pensando qué comprar.', g: '#4B5D2A,#1A2410' },
];
function personaCard(p) {
  const initials = p.name.split(' ').map((w) => w[0]).join('').replace('.', '');
  return `<article class="persona">
    <div class="persona-photo" style="--g:linear-gradient(160deg,${p.g})">
      <img src="${AS_A}img-clientes-persona-${p.id}.webp" alt="${p.name}" style="--pos-y:${p.posY || '22%'}" loading="lazy" decoding="async">
      <span class="demo-tag">Personaje de ejemplo (IA)</span>
    </div>
    <div class="persona-body">
      ${stars()}
      <p class="persona-quote">“${p.quote}”</p>
      <div><b>${p.name}</b> <span class="persona-meta">${p.meta}</span></div>
    </div>
  </article>`;
}
function personas() {
  document.querySelectorAll('[data-personas]').forEach((el) => {
    if (el.querySelector('.marquee-track')) return;
    const sec = el.closest('section');
    if (!STORE.demoPersonas) { if (sec) sec.hidden = true; return; }
    const kit = el.dataset.personas;
    const list = kit ? [...PERSONAS.filter((p) => p.kit === kit), ...PERSONAS.filter((p) => p.kit !== kit)] : PERSONAS;
    /* [2026-09-28] Este hueco es a propósito: es el lugar reservado a un
       profesional de verdad. Antes se veía como una foto que no cargó (un
       recuadro gris con un monito chico al medio), así que ahora lleva un sello
       de confianza. El borde punteado de .persona-pro se queda: marca que el
       lugar espera a alguien real.
       ⚠️ Esta tarjeta NO lleva foto de persona. Su propio texto promete un
       profesional real con nombre y registro; poner una cara inventada —de IA o
       de banco de imágenes— sería exactamente lo que dice que no hace.
       [anterior] <div class="persona-photo" style="--g:linear-gradient(160deg,#E3ECE6,#C9D8CE)"><span class="persona-initials" style="color:var(--brand)">${ic('user')}</span></div> */
    const pro = `<article class="persona persona-pro"><div class="persona-photo pro-art" aria-hidden="true"><span class="pro-seal">${ic('shield')}</span><span class="pro-kicker">Sin avales inventados</span></div><div class="persona-body"><b>¿Nutricionista o profesional de la salud?</b><p class="persona-quote" style="font-style:normal">Aquí va un profesional real, con su nombre y registro. Nunca uno inventado.</p></div></article>`;
    /* [2026-10-05] Jacsson pidió eliminar la tarjeta del profesional de la salud en todas partes. [anterior] ...${pro}... */
    el.innerHTML = `<div class="marquee-track">${list.map(personaCard).join('')}${list.map(personaCard).join('')}</div>`;
  });
}

/* ---------- marcas que vendemos (en vez de "como se vio en", que no tenemos) ---------- */
const BRANDS = ['Old School Labs', 'Selerb', 'Toplux Nutrition', 'Totaria Health', 'Buporai'];
function brandsBar() {
  document.querySelectorAll('[data-brands]').forEach((el) => {
    if (el.querySelector('.brands-track')) return;
    const run = BRANDS.map((b) => `<span>${b}</span><i>${ic('leaf')}</i>`).join('');
    el.innerHTML = `<div class="brands-track">${run.repeat(4)}</div>`;
  });
}

/* [anterior: Claude Code, 2026-09-20] aquí vivía la función del botón verde
   flotante de WhatsApp. Jacsson decidió sacar WhatsApp de la tienda: no queda botón, ni enlace,
   ni número. El contacto es el correo de STORE.email y la página de políticas.
   Si algún día vuelve, está en la bitácora del 2026-09-20 y en el historial. */

/* ---------- el juego de las cartas ----------------------------------------
   Pantalla completa. Hay 5 cartas y eliges 3. Si las 3 salen iguales te llevas
   el premio grande; si no, el 10%. Para activarlo dejas tu correo.

   ⚠️ EL % SE DESCUENTA DE LA SEGUNDA UNIDAD, NO DEL PEDIDO (Jacsson, 2026-09-20)
   Un porcentaje sobre el pedido completo no cabe en este margen: se revisaron los
   47 productos con el costeo de la bóveda (flete $6.500, 10% cancelados, 35%
   devoluciones, CPA $10.000) y el techo real es 10%, lleve 1, 2 o 3 unidades:
     · con 20% sobre 1 unidad perdían 40 de los 47 productos
     · con 30% perdían los 47, hasta -$5.653 el pedido
   No se arregla pidiendo más unidades, porque el % crece con el precio del pack
   mientras el costo por venta sigue siendo uno solo.

   Sobre la segunda unidad sí cabe, y con holgura: el 30% deja los 39 productos
   en positivo incluso con el CPA malo de $12.500 (el peor queda en $312).
   Además el premio EXIGE llevar 2, así que empuja el pack, que es lo que más
   deja ($7.575 por pedido contra $5.309 de una unidad sola).

   ⚠️ NO APLICA EN LOS 8 PRODUCTOS DE LOS BANNERS (decisión de Jacsson).
   El sello de sus banners ya promete "el 2º por $8.990" y no se puede prometer
   dos cosas distintas sobre el mismo frasco. Están en SIN_PREMIO, en productos.js,
   y su tarjeta lo dice. Si un producto entra o sale del hero, hay que mover
   también esa lista.

   CÓMO FUNCIONA EL AZAR, en dos pasos:
   1. Al abrir el juego se sortea el PREMIO GRANDE del mazo: 20% o 30%.
   2. Se reparten 5 cartas: 3 con ese premio y 2 con 10%, mezcladas. Eliges 3.
      Acertar las 3 iguales tiene 1 posibilidad entre 10 (hay 10 formas de elegir
      3 de 5, y solo una son las tres del premio grande).
   Nadie se va con las manos vacías: si no aciertas, igual te llevas el 10%.

   Si se cambia un porcentaje o se aplica sobre otra cosa HAY QUE REHACER EL
   CÁLCULO producto por producto. No basta con mirar el promedio: con el reparto
   anterior el promedio daba positivo mientras 40 productos perdían plata.

   ⚠️ SÍ se junta con los packs —de hecho los exige—, pero NO con los kits, que
   ya vienen armados con precio de oferta.
   ⚠️ SOLO LA PRIMERA COMPRA, y vence a las 24 horas de ganarlo. */
const store = {
  get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
  set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* sin almacenamiento */ } },
};

/* Los repartos posibles del mazo. En cada partida se elige uno al azar y se
   mezcla, así al recargar la página salen opciones distintas (Jacsson,
   2026-09-20). Antes era una lista fija y siempre aparecían los mismos valores.

   ⚠️ DOS REGLAS QUE NO SE PUEDEN ROMPER:
   1. Como mucho DOS cartas de 40%. Para ganar hacen falta tres iguales, así que
      con dos el 40% es imposible por construcción, no por mala suerte. Es el
      señuelo que pidió Jacsson: se ve al destapar todo, pero no se gana.
   2. Al menos tres valores distintos en cada reparto, para que la mesa no quede
      toda igual.

   Se puede variar la frecuencia sin rehacer las cuentas porque cada premio por
   separado ya está verificado contra el margen: el 10%, el 20% y el 30% dejan
   utilidad en los 39 productos que participan, incluso con el CPA malo de
   $12.500. Como ninguno pierde plata, da lo mismo cuál salga más seguido.
   Lo que SÍ obliga a recalcular es agregar un premio nuevo o subir un
   porcentaje. Ver el bloque del juego, más abajo.

   Qué se puede ganar con cada reparto (sobre 120 formas de elegir 3 de 10):
     A → 30% 1 vez, 20% 10 veces       · promedio 11,00%
     B → 30% 4 veces, 20% 4 veces      · promedio 11,00%
     C → 30% 1 vez, 20% 1 vez          · promedio 10,25%
     D → 30% 10 veces, 20% 1 vez       · promedio 11,75%
     E → 30% 4 veces, 20% 1 vez        · promedio 10,75%
   Comprobado enumerando las 120 combinaciones de cada uno. */
const REPARTOS = [
  [40, 40, 30, 30, 30, 20, 20, 20, 20, 20],
  [40, 40, 30, 30, 30, 30, 20, 20, 20, 20],
  [40, 40, 30, 30, 30, 20, 20, 20, 10, 10],
  [40, 40, 30, 30, 30, 30, 30, 20, 20, 20],
  [40, 40, 30, 30, 30, 30, 20, 20, 20, 10],
];
const PREMIO_BASE = 10;   // el consuelo: no está en las cartas, se da si no aciertas
const HORAS = 24;
/* Cuántas unidades pide cada premio. El 40% pide 3 porque con 2 el Tripack NAD
   queda en rojo si el CPA se va a $12.500; con 3 aguantan los 39 productos.
   ⚠️ Si se agrega un premio o se cambia un mínimo, rehacer el cálculo. */
const MIN_PREMIO = { 10: 2, 20: 2, 30: 2, 40: 3 };


/* [2026-10-05] Textos del juego: en Shopify salen de la sección "Juego de descuento" (AS.juegoTextos);
   si un texto está vacío, se usa el de siempre. {pct}, {tope}, {horas}, {min}, {monto}, {codigo} se reemplazan. */
const TXJ_BASE = {"tab_hasta": "HASTA", "tab_off": "OFF", "tab_reloj": "{pct}% · {h}h {m}m", "kicker": "Solo para tu primer pedido", "titulo": "Elige <em>3 de 10</em>", "bajada": "Descuento en tu <b>segunda unidad</b>. Si las tres salen iguales, te llevas ese premio; si no, igual te vas con tu {base}%.", "hint_0": "Toca una carta para empezar", "hint_1": "¡{pct}%! Te quedan 2", "hint_2_iguales": "¡Dos iguales! Una más…", "hint_2": "Queda una carta…", "hint_3_iguales": "¡LAS TRES IGUALES! {pct}%", "hint_3": "No salieron tres iguales…", "win_big": "{pct}% OFF", "win_iguales": "¡Las tres iguales! Ganaste {pct}%", "win_consuelo_t": "Igual te llevas un {pct}%", "consuelo": "Tranquilo, no pasa nada: no queremos que te vayas con las manos vacías.", "win_sub": "Se descuenta de tu segunda unidad, llevando {min} o más, en productos seleccionados. Solo se activa dejando tu correo.", "win_btn": "Activar mi {pct}%", "correo": "tu@correo.cl", "error": "Revisa tu correo: falta la @ o el dominio (ej: nombre@gmail.com).", "letra": "Para tu primer pedido, <b>en la segunda unidad</b> y en productos seleccionados. <b>Vence en {horas} horas.</b> El {tope}% se aplica llevando 3 unidades; los demás, desde 2. Los productos que ya traen el 2º a precio fijo no participan, y tampoco los kits, que vienen con precio de oferta. Te enviaremos novedades; puedes darte de baja cuando quieras.", "listo": "¡Listo! Tu {pct}% está activo", "listo_texto": "Ya lo aplicamos en los precios. Si pagas desde otro dispositivo, usa este código.", "plazo": "Tienes {horas} horas para usarlo", "listo_btn": "Ver mi rutina", "saltar": "No gracias", "aviso_activo": "Tu {pct}% ya está activo. Código: {codigo}", "linea_kit": "El kit ya tiene precio de oferta", "linea_fijo": "Este ya tiene el 2º por {monto}", "linea_min": "Tu {pct}% se activa llevando {min}", "linea_con": "Con tu {pct}%: {monto}"};
function tx(k, vars) {
  const propio = window.AS && window.AS.juegoTextos && window.AS.juegoTextos[k];
  let t = (propio && String(propio).trim()) ? propio : TXJ_BASE[k];
  Object.entries(vars || {}).forEach(([a, b]) => { t = t.split('{' + a + '}').join(b); });
  return t;
}

function discountGame() {
  const tope = STORE.welcomeMax;   // el "hasta 40%" del cartel, antes de jugar
  /* Lo ganado vive en el navegador: el porcentaje y cuándo vence. */
  const vence = () => +(store.get('as-disc-hasta') || 0);
  const vigente = () => store.get('as-disc') === '1' && Date.now() < vence();
  const won = vigente;
  const miPct = () => +(store.get('as-disc-pct') || PREMIO_BASE);

  /* Pinta la línea del descuento de una tarjeta. Cuatro casos:
     - kit ([data-oferta]): no recibe nada, ya viene con precio armado.
     - producto de los banners ([data-sin-premio]): su sello ya promete el 2º a
       un precio fijo, y no se puede prometer dos cosas del mismo frasco.
     - lleva 1 unidad: el premio es sobre la segunda, así que se le dice.
       Es el caso que empuja al pack, y es a propósito.
     - lleva 2 o 3: se descuenta el % de la unidad extra. */
  const pinta = (el) => {
    const d = miPct();
    if (el.hasAttribute('data-oferta')) {
      el.textContent = tx('linea_kit');
      el.classList.add('disc-no');
      return;
    }
    if (el.hasAttribute('data-sin-premio')) {
      el.textContent = tx('linea_fijo', { monto: clp(+el.dataset.extra) });
      el.classList.add('disc-no');
      return;
    }
    const lleva = +(el.dataset.unidades || 1);
    const min = MIN_PREMIO[d] || 2;
    if (lleva < min) {
      el.textContent = tx('linea_min', { pct: d, min });
      el.classList.add('disc-no');
      return;
    }
    /* El descuento sale de la unidad extra, no del pedido completo. */
    const rebaja = Math.round(+el.dataset.extra * d / 100);
    el.classList.remove('disc-no');
    el.textContent = tx('linea_con', { pct: d, monto: clp(+el.dataset.discPrice - rebaja) });
  };

  /* Se deja a mano para poder recalcular una sola tarjeta al cambiar de pack. */
  window.aplicaDescuento = (raiz) => {
    if (!vigente()) return;
    (raiz || document).querySelectorAll('[data-disc-price]').forEach(pinta);
  };

  const apply = () => {
    if (!vigente()) return;
    const d = miPct();
    document.body.classList.add('has-disc');
    document.querySelectorAll('[data-disc-price]').forEach(pinta);
    const tab = document.querySelector('.disc-tab');
    if (tab) { tab.classList.add('won'); tab.innerHTML = `${ic('check')}${d} % activo`.replace(' %', '%'); }
    relojDescuento();
  };

  /* Cuenta atrás de las 24 horas, en el botón flotante. */
  function relojDescuento() {
    const tab = document.querySelector('.disc-tab');
    if (!tab) return;
    clearInterval(tab._reloj);
    const pinta = () => {
      const queda = vence() - Date.now();
      if (queda <= 0) {
        clearInterval(tab._reloj);
        store.set('as-disc', '0');
        document.body.classList.remove('has-disc');
        tab.classList.remove('won');
        tab.innerHTML = `${ic('gift')}<span class="larga">${tx('tab_hasta')} </span>${tope}%<span class="larga"> ${tx('tab_off')}</span>`;
        document.querySelectorAll('[data-disc-price]').forEach((el) => { el.textContent = ''; });
        return;
      }
      const h = Math.floor(queda / 3.6e6);
      const m = Math.floor(queda % 3.6e6 / 6e4);
      tab.innerHTML = `${ic('check')}${tx('tab_reloj', { pct: miPct(), h, m: String(m).padStart(2, '0') })}`;
    };
    pinta();
    tab._reloj = setInterval(pinta, 30000);
  }

  document.body.insertAdjacentHTML('beforeend', `
  <!-- [2026-10-03] El texto va envuelto en un <span> para poder encogerlo en el
       teléfono cuando aparece la barra de compra: ahí el globito tapaba una línea
       entera de la ficha. Encogido queda el regalo y "40%", que se entiende igual
       y ocupa menos de la mitad. El aria-label mantiene la frase completa para
       quien usa lector de pantalla. -->
  <button class="disc-tab" type="button" data-open-game aria-label="Descubrir mi descuento">${ic('gift')}<span class="larga">${tx('tab_hasta')} </span>${tope}%<span class="larga"> ${tx('tab_off')}</span></button>
  <div class="game" role="dialog" aria-modal="true" aria-labelledby="game-t">
    <button class="game-x" type="button" aria-label="Cerrar">${ic('x')}</button>
    <div class="game-inner">
      <img class="game-logo" src="${AS_A}img-logo-light.png" alt="${STORE.name}">
      <div class="game-play" style="display:grid;gap:14px;justify-items:center">
        <span class="game-kicker">${ic('gift')} ${(CAMPANA.juego && CAMPANA.juego.kicker) || tx('kicker')}</span>
        <h2 id="game-t">${(CAMPANA.juego && CAMPANA.juego.titulo) || tx('titulo')}</h2>
        <p>${(CAMPANA.juego && CAMPANA.juego.bajada) || tx('bajada', { base: PREMIO_BASE })}</p>
        <div class="cards" data-cards></div>
        <div class="game-track" aria-hidden="true"><i></i><i></i><i></i></div>
        <span class="game-hint" aria-live="polite">${tx('hint_0')}</span>
      </div>
      <div class="game-win" hidden>
        <span class="win-big">${tope}% OFF</span>
        <h2 style="font-size:1.6rem" data-win-t>Ganaste tu descuento</h2>
        <!-- Solo se usa cuando NO salen las tres iguales: que nadie sienta que
             jugó y perdió. Va antes de las condiciones, no después. -->
        <p class="win-consuelo" data-win-consuelo hidden></p>
        <p style="justify-self:center" data-win-sub>Déjanos tu correo para activarlo. Se aplica solo al pagar.</p>
        <form class="game-form" novalidate>
          <label class="sr" for="game-mail">Tu correo</label>
          <input id="game-mail" type="email" inputmode="email" autocomplete="email" placeholder="${tx('correo')}" required>
          <span class="game-err" aria-live="polite"></span>
          <button class="btn btn-cta btn-block" type="submit" data-win-btn>Activar mi descuento ${ic('arrow')}</button>
        </form>
        <small>${tx('letra', { horas: HORAS, tope })}</small>
      </div>
      <div class="game-done" hidden style="display:grid;gap:14px;justify-items:center">
        <h2 style="font-size:1.7rem" data-done-t>¡Listo! Tu descuento está activo</h2>
        <span class="game-code" data-done-code>${STORE.welcomeCode}</span>
        <p>${tx('listo_texto')}</p>
        <span class="game-plazo">${ic('clock')} ${tx('plazo', { horas: HORAS })}</span>
        <button class="btn btn-cta btn-block" type="button" data-game-close>${tx('listo_btn')} ${ic('arrow')}</button>
      </div>
      <button class="game-skip" type="button" data-game-close>${tx('saltar')}</button>
    </div>
  </div>`);

  const g = document.querySelector('.game');

  /* Cambia de pantalla sin corte: la que sale se desvanece hacia arriba y la que
     entra sube desde abajo. Antes se hacía con `hidden`, de un frame al otro, y
     se sentía pegado. `prepara` se ejecuta con la nueva ya montada pero todavía
     invisible, para poder escribir sus textos antes de que se vea. */
  const PASO = 340;   // igual que el .34s de .game-fuera, en styles.css
  const cambiaPantalla = (sale, entra, prepara) => {
    sale.classList.add('game-fuera');
    setTimeout(() => {
      sale.hidden = true;
      sale.classList.remove('game-fuera', 'game-entra');
      entra.hidden = false;
      entra.style.display = 'grid';
      if (prepara) prepara();
      entra.classList.remove('game-entra');
      void entra.offsetWidth;      // reinicia la animación
      entra.classList.add('game-entra');
    }, PASO);
  };

  /* Una sola vez por dispositivo: al abrirse queda marcado y, al recargar, ni el juego ni el botón vuelven (Jacsson, 2026-10-05). */
  const open = () => { g.classList.add('open'); document.body.style.overflow = 'hidden'; store.set('as-game-seen', '1'); };
  const close = () => { g.classList.remove('open'); document.body.style.overflow = ''; store.set('as-game-seen', '1'); };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-game]')) {
      if (won()) toast(tx('aviso_activo', { pct: miPct(), codigo: `BIENVENIDA${miPct()}` }));
      else open();   /* si ya venció, se puede volver a jugar */
    }
  });
  g.querySelectorAll('[data-game-close], .game-x').forEach((b) => b.addEventListener('click', close));
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && g.classList.contains('open')) close(); });

  /* ---- el mazo -----------------------------------------------------------
     10 cartas en dos filas de 5, mezcladas: 3 de 40%, 3 de 30% y 4 de 20%.
     Eliges 3; si las tres coinciden te llevas ese premio, y si no, el 10%.
     Hay 120 formas de elegir 3 de 10, así que:
       · 40% → 1 forma  = 0,83%   (1 de cada 120)
       · 30% → 1 forma  = 0,83%
       · 20% → 4 formas = 3,33%
       · 10% de consuelo el 95% de las veces
     Descuento promedio sobre la segunda unidad: 10,75%.
     ⚠️ Si se cambia el reparto del mazo cambian estas probabilidades y hay que
     rehacer el cálculo de márgenes producto por producto.
     [anterior] se sorteaba un premio grande y el mazo era 5 de ese y 5 del 10%:
     cuando salía 20%, el 40% no se veía nunca en la mesa. */
  const mezcla = (a) => {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  /* Un reparto distinto en cada partida, mezclado. */
  const mazo = mezcla([...REPARTOS[Math.floor(Math.random() * REPARTOS.length)]]);

  const caja = g.querySelector('[data-cards]');
  caja.innerHTML = mazo.map((v, n) => `
    <button class="card" type="button" style="--i:${n}" aria-label="Destapar carta ${n + 1} de 10">
      <span class="card-face card-back"><span class="card-mark">?</span></span>
      <span class="card-face card-front${v >= 30 ? ' alto' : ''}">
        <img src="${AS_A}img-favicon-180.png" alt=""><b>${v}%</b>
      </span>
    </button>`).join('');

  let flipped = 0;
  const elegidas = [];
  const hint = g.querySelector('.game-hint');
  const track = g.querySelectorAll('.game-track i');
  const cartas = [...caja.querySelectorAll('.card')];

  /* Si nadie toca nada en 4 s, una carta al azar se mueve sola para invitar. */
  let ocio = setInterval(() => {
    if (flipped) return clearInterval(ocio);
    const libres = cartas.filter((c) => !c.classList.contains('flip'));
    const c = libres[Math.floor(Math.random() * libres.length)];
    if (!c) return;
    c.classList.add('tenta');
    setTimeout(() => c.classList.remove('tenta'), 900);
  }, 4000);

  cartas.forEach((c, i) => c.addEventListener('click', () => {
    if (c.classList.contains('flip') || flipped >= 3) return;
    clearInterval(ocio);
    c.classList.add('flip');
    elegidas.push(mazo[i]);
    flipped++;
    if (track[flipped - 1]) track[flipped - 1].classList.add('on');

    /* El texto comenta lo que va saliendo, sin adelantar el resultado. */
    const todasIguales = elegidas.every((v) => v === elegidas[0]);
    if (flipped === 1) hint.textContent = tx('hint_1', { pct: elegidas[0] });
    else if (flipped === 2) hint.textContent = todasIguales ? tx('hint_2_iguales') : tx('hint_2');
    hint.classList.remove('late'); void hint.offsetWidth; hint.classList.add('late');

    if (flipped === 3) {
      /* Ganas el premio grande solo si las tres coinciden. Si no, el 10%. */
      const gane = todasIguales ? elegidas[0] : PREMIO_BASE;
      hint.textContent = todasIguales ? tx('hint_3_iguales', { pct: gane }) : tx('hint_3');
      caja.classList.add('gano');

      /* las dos que quedaron sin elegir también se dan vuelta */
      /* Las 7 que no jugaste se destapan en cascada. Con 10 cartas, 160 ms entre
         una y otra se hacía largo: a 90 ms la ola se lee igual y no cansa. */
      cartas.filter((x) => !x.classList.contains('flip'))
            .forEach((x, k) => setTimeout(() => x.classList.add('flip', 'resto'), 380 + k * 90));

      /* 1,9 s para que alcance a verse el remate del tablero antes del cambio. */
      setTimeout(() => {
        store.set('as-disc-pct', gane);
        const w = g.querySelector('.game-win');
        g.querySelector('.game-skip').hidden = true;
        cambiaPantalla(g.querySelector('.game-play'), w, () => {
          w.querySelector('.win-big').textContent = tx('win_big', { pct: gane });
          w.querySelector('[data-win-t]').textContent = todasIguales
            ? tx('win_iguales', { pct: gane })
            : tx('win_consuelo_t', { pct: gane });
          /* Cuando no salen las tres iguales, el cliente acaba de "perder". Si la
             pantalla solo le dice el número, se va con esa sensación. Esta línea
             está para eso y solo aparece en ese caso (Jacsson, 2026-09-20). */
          const cons = w.querySelector('[data-win-consuelo]');
          cons.hidden = todasIguales;
          cons.textContent = todasIguales ? ''
            : tx('consuelo');
          /* La condición y el mínimo se dicen AQUÍ, antes de pedir el correo. */
          w.querySelector('[data-win-sub]').textContent =
            tx('win_sub', { min: MIN_PREMIO[gane] });
          w.querySelector('[data-win-btn]').innerHTML = `${tx('win_btn', { pct: gane })} ${ic('arrow')}`;
        });
        /* El confeti va con la pantalla nueva, no con la vieja. */
        if (todasIguales) setTimeout(confetti, PASO);
        /* El foco se mueve cuando la pantalla ya está, o el navegador salta. */
        setTimeout(() => g.querySelector('#game-mail').focus({ preventScroll: true }), PASO + 260);
      }, 1900);
    }
  }));

  g.querySelector('.game-form').addEventListener('submit', (e) => {
    e.preventDefault();
    const v = g.querySelector('#game-mail').value.trim();
    const err = g.querySelector('.game-err');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { err.textContent = tx('error'); return; }
    err.textContent = '';
    /* Aquí empieza a correr el plazo: se guarda el porcentaje y hasta cuándo vale. */
    const gane = +(store.get('as-disc-pct') || PREMIO_BASE);
    store.set('as-disc', '1');
    store.set('as-disc-hasta', Date.now() + HORAS * 3600e3);
    const done = g.querySelector('.game-done');
    cambiaPantalla(g.querySelector('.game-win'), done, () => {
      done.querySelector('[data-done-t]').textContent = tx('listo', { pct: gane });
      done.querySelector('[data-done-code]').textContent = `BIENVENIDA${gane}`;
    });
    apply();
    // En Shopify: aquí se envía el correo a Klaviyo/Shopify Email y se aplica el código en el checkout.
  });

  if (store.get('as-game-seen')) document.querySelector('.disc-tab')?.remove();
  if (won()) apply();
  else if (!store.get('as-game-seen') && document.body.dataset.page !== 'test') {
    /* Si la entrada de Halloween está puesta, el juego espera a que se cierre:
       dos pop-ups encima no se leen. */
    if (document.querySelector('.hw-intro')) {
      document.addEventListener('hw-intro-cerrada', () => setTimeout(open, 2200), { once: true });
    } else {
      setTimeout(open, 6000);
    }
  }
}
function confetti() {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const box = document.createElement('div');
  box.className = 'confetti';
  const colors = ['#FFB400', '#FF5A1F', '#FFFFFF', '#6FCF97', '#F6E3EC'];
  box.innerHTML = Array.from({ length: 70 }, () => `<i style="left:${Math.random() * 100}%;background:${colors[Math.floor(Math.random() * colors.length)]};animation-duration:${1.6 + Math.random() * 1.6}s;animation-delay:${Math.random() * .4}s"></i>`).join('');
  document.body.appendChild(box);
  setTimeout(() => box.remove(), 3800);
}

/* ── HERO: los banners terminados ──────────────────────────────────────────────
   Cada banner es una imagen completa (título, sello y precio vienen dentro).
   Los originales en PNG están en la bóveda, en
   `02 - 📦 Productos/📸 Fotos de productos/8 - Banner Listos/`, con el nombre del
   producto y la versión. Aquí se sirven en WebP (de 2 MB a ~170 KB cada uno).

   Para cambiar un banner: deja el PNG nuevo en esa carpeta, pásalo a WebP en
   `${AS_A}img-banners-` con el mismo nombre y listo. No hay que tocar nada más.

   `movil`: nombre del archivo de la versión vertical, para pantallas de menos de
   760 px. Mientras un banner no lo tenga, en el celular se muestra el ancho
   completo (se ve entero, pero pequeño). Medidas en la nota
   `🖼️ Banners del inicio - Medidas y combinaciones`.

   ⚠️ Van solo los que están correctos. Quedaron FUERA, y por qué:
   · 72697 Liver Complex — la v3 decía "CALIDAD SUIZA"; la v4 lo quitó, pero su
     etiqueta recreada dice "a base de silimarina... y colina" y el frasco real
     solo declara selenio y L-cisteína. Inventa ingredientes.
   · 125747 NAD+ Selerb v4 — le cambiaron la etiqueta al frasco para tapar
     "Prostate Health": el envase del banner no es el que recibe el cliente.
   Los dos ya están convertidos en ${AS_A}img-banners-, listos para entrar en
   cuanto se corrijan.
   [2026-09-20] 103967 Sleep Zen ENTRÓ: su v4 ya no dice "calidad suiza" y la
   marca quedó bien (Swiss Trading Group, antes decía Swiss Nutrition Group).

   ⚠️ REGLA (Jacsson, 2026-09-19): si un banner muestra varios productos, todos
   tienen que ser DEL MISMO PROVEEDOR. Cada proveedor despacha por su cuenta.
   Estos cinco son de un solo producto, así que no aplica.

   [anterior] el hero componía el banner con CSS: título, subtítulo, sello y tres
   fotos recortadas, con una paleta por tema. Esa versión está guardada entera en
   `_respaldo-hero-abanico.html`, y las fotos recortadas siguen en ${AS_A}img-hero-. */
const HERO_BANNERS = [
  /* [reordenado 2026-09-20] El colágeno abría el carrusel y su fondo blanco se
     confunde con el de la página: parecía que no había banner. Ahora abre el
     magnesio, que es azul noche y corta contra la cabecera clara.
     El orden alterna fondos oscuros y claros, y deja los dos banners de sueño
     (magnesio y Sleep Zen) en los extremos para que no salgan seguidos. */
  /* [anterior: Codex, 2026-09-20] { img: '126340-magnesio', movil: '126340-magnesio-movil', id: 126340, ... } */
  /* [2026-09-21, Claude Code] Codex dejó este banner en PNG (2,2 MB escritorio,
     2,1 MB celular) y es el PRIMERO del carrusel: lo primero que carga la tienda.
     Se convirtió a webp (237 y 232 KB). Los PNG de Codex siguen en la carpeta. */
  { img: '126340-magnesio-cta-naranja', movil: '126340-magnesio-movil-cta-naranja', id: 126340,
    alt: 'Seis tipos de magnesio: bisglicinato, citrato, malato, treonato, taurato y óxido. Lleva 2 y el segundo por $10.000. 60 cápsulas de 720 mg.' },
  { img: '125749-joint', movil: '125749-joint-movil',    id: 125749,
    alt: 'Joint Health, cuatro en uno para tus articulaciones: magnesio, colágeno, cúrcuma y jengibre. Lleva el segundo por $8.990. 60 cápsulas.' },
  { img: '54685-nad', movil: '54685-nad-movil',       id: 54685,
    alt: 'NAD+ y resveratrol, dos en uno, 810 mg por cápsula. Lleva 2 y el segundo por $8.990. 30 cápsulas, envío a todo Chile.' },
  { img: '96544-hepa', movil: '96544-hepa-movil',      id: 96544,
    alt: 'Hepa Health, siete hierbas en un frasco: boldo, diente de león, cola de caballo, menta, bacurina, llavelo y hepa. Lleva 2 y el segundo por $12.900. 90 cápsulas de 400 mg.' },
  { img: '84659-colageno', movil: '84659-colageno-movil',  id: 84659,
    alt: 'Colágeno en cápsulas, tipo I hidrolizado. Lleva 2 y el segundo por $8.990. 60 cápsulas.' },
  { img: '103967-sleepzen', movil: '103967-sleepzen-movil', id: 103967,
    alt: 'Sleep Zen: duerme y descansa. Triptófano, magnesio, zinc y vitaminas B6, B12, D3 y E. Lleva 2 y el segundo por $14.000. 30 g, desarrollado en USA.' },

  /* ═══ BANNERS DEL CYBERMONDAY ═══════════════════════════════════════════
     [2026-10-01] Compuestos aquí, no generados por IA: fondo plano con formas +
     el RECORTE REAL del producto (${AS_A}img-hero-). Por eso la etiqueta es la
     verdadera, sin cápsulas inventadas ni marcas mal escritas.

     La estructura la pidió Jacsson copiando dos banners de referencia (Sunvit y
     Nutrex): titular a la izquierda, frascos al centro, el descuento en un
     recuadro a la derecha. El recuadro va dibujado en la imagen y el texto se
     pinta encima por HTML, así se puede cambiar sin rehacer nada.

     Los de producto llevan DOS frascos porque la oferta es 2x1: se entiende sin
     leer. El genérico lleva tres distintos, que es lo que dice "seleccionados".

     Se apagan solos el 8 de octubre, cuando entra Halloween.

     [2026-10-02] LAS 5 FOTOS NATURALES. Jacsson mandó 10 fotos de producto en
     ambiente natural (luz de día, los ingredientes reales de cada etiqueta) y
     pidió aplicarlas: *"da lo mismo los colores, solo aplícalas así"*. Van de
     banner de CELULAR, con `claro: true`.

     Solo en celular porque las 10 vienen VERTICALES (4:5 exacto). El banner de
     escritorio es 1800x651, casi tres veces más ancho: recortar una vertical a
     eso deja el frasco fuera. Mientras no haya horizontales, escritorio sigue
     con el banner compuesto.

     [2026-10-02, 2ª vuelta] Jacsson rehízo las 5 con el TEXTO YA PUESTO en la
     imagen: titular, beneficios y el 2x1. Quedaron muy bien y las letras salen
     limpias, así que estas reemplazan a las anteriores.

     `textoEnFoto: true` le pone al slide la clase `.con-texto`, y el CSS esconde
     el titular y el 2x1 del HTML en celular. Si no, saldrían DOS veces: el de la
     foto y el que pinta la página encima. En escritorio el banner sigue siendo el
     compuesto, que sí necesita el texto del HTML.

     Se apagan solas el 8 de octubre, con el resto del Cyber. */
  /* [2026-10-03] APAGADOS, no borrados. Jacsson: *"estas son las dos imágenes
     que hay que sacar porque están horribles, deberíamos solo dejar las del
     cyber"*. Son los dos únicos banners que seguían usando mi composición por
     código en celular, porque de estos dos productos no hay foto suya.
     Para encenderlos: dejar las imágenes nuevas y borrar `pendiente: true`. */
  /* [2026-10-03] PRESENTACIÓN DEL CYBER, el primero del carrusel. Jacsson pidió
     un banner de apertura ("hasta 50% dcto", envío gratis, 2x1). Hecho completo
     por gpt-image-2 con los 5 frascos reales: herramientas/cyber-portada.py.
     "Hasta 50%" es verdad: el 2x1 deja cada frasco a la mitad.
     [anterior: Claude Code, 2026-10-03] img 'cyber-2x1' / movil 'cyber-2x1-movil'
     y `pendiente: true` (apagado por feo). */
  /* [2026-10-03] ANTES del Cyber: "Nos adelantamos al Cyber", sin fecha, fondo
     oscuro, 50% y 2x1 del mismo tamaño, envío gratis en franja dorada.
     Se apaga solo el 4 de octubre a las 23:59 (hora de Chile). */
  /* [2026-10-03] DOS banners de apertura en vez de uno (Jacsson: uno para el 50%
     y otro para el 2x1, sin repetir productos y con distinta disposición).
     herramientas/cyber-dos-banners.py. Se apagan solos el 4 oct 23:59. */
  { img: 'cyber-50-1', movil: 'cyber-50-movil-1', id: 49208, campana: 'cyber',
    textoEnFoto: true, textoEnFotoEscritorio: true, href: 'productos.html',
    hasta: '2026-10-04T23:59:59-03:00',
    alt: 'Nos adelantamos al Cyber: hasta 50% de descuento en productos seleccionados. Envío gratis a todo Chile.' },

  { img: 'cyber-2x1-1', movil: 'cyber-2x1-movil-1', id: 49208, campana: 'cyber',
    textoEnFoto: true, textoEnFotoEscritorio: true, href: 'productos.html',
    hasta: '2026-10-04T23:59:59-03:00',
    alt: 'Nos adelantamos al Cyber: 2x1, lleva 2 y paga 1 en productos seleccionados. Envío gratis a todo Chile.' },

  /* [2026-10-03] GUARDADO Y APAGADO: el banner único que Jacsson aprobó
     (*"ese sí está perfecto"*) antes de pedir separarlo en dos. Para volver a
     usarlo, borrar `pendiente: true`. */
  { img: 'cyber-adelanto-1', movil: 'cyber-adelanto-movil-1', id: 49208, campana: 'cyber',
    textoEnFoto: true, textoEnFotoEscritorio: true, href: 'productos.html',
    hasta: '2026-10-04T23:59:59-03:00', pendiente: true,
    alt: 'Nos adelantamos al Cyber: hasta 50% de descuento y 2x1 en productos seleccionados. Envío gratis a todo Chile y pagas al recibir.' },

  /* [2026-10-03, corrección de Jacsson] TRES ETAPAS de banners: *"imágenes antes
     del Cyber, durante el Cyber y después del Cyber, que son las que alargamos"*.
     Las de ANTES son las dos de arriba (hasta el 4). Estas son DURANTE y DESPUÉS,
     los mismos dos banners aprobados con otra píldora (herramientas/cyber-con-fecha.py).
     [anterior: Claude Code, misma noche] una sola versión del 5 al 10 que decía
     "CYBERMONDAY · HASTA EL 10 DE OCTUBRE" (cyber-*-fecha-1): Jacsson la rechazó,
     el Cyber normal dura hasta el 7 y el 10 recién se cuenta el 8. */
  // DURANTE (5 al 7): "CYBERMONDAY · 5 AL 7 DE OCTUBRE"
  { img: 'cyber-50-durante-1', movil: 'cyber-50-movil-durante-1', id: 49208, campana: 'cyber',
    textoEnFoto: true, textoEnFotoEscritorio: true, href: 'productos.html',
    desde: '2026-10-05T00:00:00-03:00', hasta: '2026-10-07T23:59:59-03:00',
    alt: 'CyberMonday del 5 al 7 de octubre: hasta 50% de descuento en productos seleccionados. Envío gratis a todo Chile.' },
  { img: 'cyber-2x1-durante-1', movil: 'cyber-2x1-movil-durante-1', id: 49208, campana: 'cyber',
    textoEnFoto: true, textoEnFotoEscritorio: true, href: 'productos.html',
    desde: '2026-10-05T00:00:00-03:00', hasta: '2026-10-07T23:59:59-03:00',
    alt: 'CyberMonday del 5 al 7 de octubre: 2x1, lleva 2 y paga 1 en productos seleccionados. Envío gratis a todo Chile.' },
  // DESPUÉS (8 al 10): "TE ENTENDEMOS: ALARGAMOS EL CYBER HASTA EL 10"
  { img: 'cyber-50-extendido-1', movil: 'cyber-50-movil-extendido-1', id: 49208, campana: 'cyber',
    textoEnFoto: true, textoEnFotoEscritorio: true, href: 'productos.html',
    desde: '2026-10-08T00:00:00-03:00',
    alt: 'Te entendemos: alargamos el Cyber hasta el 10 de octubre. Hasta 50% de descuento en productos seleccionados. Envío gratis a todo Chile.' },
  { img: 'cyber-2x1-extendido-1', movil: 'cyber-2x1-movil-extendido-1', id: 49208, campana: 'cyber',
    textoEnFoto: true, textoEnFotoEscritorio: true, href: 'productos.html',
    desde: '2026-10-08T00:00:00-03:00',
    alt: 'Te entendemos: alargamos el Cyber hasta el 10 de octubre. 2x1, lleva 2 y paga 1 en productos seleccionados. Envío gratis a todo Chile.' },

  /* DURANTE el Cyber (5 al 7 de octubre): la versión con fecha. Jacsson: *"esa
     imagen sí guárdala para cuando ya estemos dentro de la fecha"*.
     [2026-10-03] APAGADO (pendiente): la imagen dice "5 AL 7 DE OCTUBRE" y el
     Cyber se alargó al 10. Lo reemplazan los dos de arriba. */
  { img: 'cyber-portada-1', movil: 'cyber-portada-movil-1', id: 49208, campana: 'cyber',
    textoEnFoto: true, textoEnFotoEscritorio: true, href: 'productos.html',
    desde: '2026-10-05T00:00:00-03:00', pendiente: true,
    alt: 'CyberMonday del 5 al 7 de octubre: hasta 50% de descuento en productos seleccionados. 2x1, envío gratis a todo Chile y pagas al recibir.',
    titular: 'Solo <em>72 horas</em>',
    texto: { arriba: 'CyberMonday', precio: '2x1', abajo: 'en productos seleccionados' } },

  { img: '49208-cyber', movil: '49208-cyber-movil', id: 49208, campana: 'cyber',
    pendiente: true,
    alt: 'Curvy Gummies: gomitas de aguaje y fenogreco con probióticos y prebióticos. 2x1 por CyberMonday. 160 gomitas.',
    titular: 'Curvy <em>Gummies</em>',
    texto: { arriba: 'CyberMonday', precio: '2x1', abajo: 'el 2º a $0 · hasta agotar stock' } },

  /* [2026-10-03] Escritorio hecho COMPLETO por gpt-image-2 (texto, 2x1 y frasco
     real), estilo de los de celular: herramientas/cyber-escritorio-v3.py.
     [anterior: Claude Code] img: '65555-cyber' (compuesto por código) */
  { img: '65555-cyber-v3-2', movil: '65555-texto-movil', textoEnFoto: true, textoEnFotoEscritorio: true, id: 65555, campana: 'cyber',
    unidades: 2,   // el banner promete 2x1: la ficha abre con 2 ya elegidas
    ahorro: { antes: '$89.800', ahora: '$44.900', ahorras: '$44.900' },
    alt: 'Hallprost Ultra: pepa de calabaza y óxido de zinc. 2x1 por CyberMonday. 60 cápsulas.',
    titular: 'Hallprost <em>Ultra</em>',
    texto: { arriba: 'CyberMonday', precio: '2x1', abajo: 'el 2º a $0 · hasta agotar stock' } },

  /* [2026-10-03] Escritorio hecho COMPLETO por gpt-image-2 (texto, 2x1 y frasco
     real), estilo de los de celular: herramientas/cyber-escritorio-v3.py.
     [anterior: Claude Code] img: '158579-cyber' (compuesto por código) */
  { img: '158579-cyber-v3-1', movil: '158579-texto-movil', textoEnFoto: true, textoEnFotoEscritorio: true, id: 158579, campana: 'cyber',
    unidades: 2,   // el banner promete 2x1: la ficha abre con 2 ya elegidas
    ahorro: { antes: '$89.800', ahora: '$44.900', ahorras: '$44.900' },
    // [2026-10-04] son gotas, no cápsulas (ficha y foto). [anterior: Claude Code] 'drenaje linfático en cápsulas'
    alt: 'Aurelys: drenaje linfático, 8 plantas en gotas. 2x1 por CyberMonday.',
    titular: 'Drenaje <em>linfático</em>',
    texto: { arriba: 'CyberMonday', precio: '2x1', abajo: 'el 2º a $0 · hasta agotar stock' } },

  /* [2026-10-03] Escritorio hecho COMPLETO por gpt-image-2 (texto, 2x1 y frasco
     real), estilo de los de celular: herramientas/cyber-escritorio-v3.py.
     [anterior: Claude Code] img: '83439-cyber' (compuesto por código) */
  { img: '83439-cyber-v3-1', movil: '83439-texto-movil', textoEnFoto: true, textoEnFotoEscritorio: true, id: 83439, campana: 'cyber',
    unidades: 2,   // el banner promete 2x1: la ficha abre con 2 ya elegidas
    ahorro: { antes: '$89.800', ahora: '$44.900', ahorras: '$44.900' },
    alt: 'Gomitas de shilajit. 2x1 por CyberMonday.',
    titular: 'Shilajit <em>en gomitas</em>',
    texto: { arriba: 'CyberMonday', precio: '2x1', abajo: 'el 2º a $0 · hasta agotar stock' } },

  /* [2026-10-03] Escritorio hecho COMPLETO por gpt-image-2 (texto, 2x1 y frasco
     real), estilo de los de celular: herramientas/cyber-escritorio-v3.py.
     [anterior: Claude Code] img: '67632-cyber' (compuesto por código) */
  { img: '67632-cyber-v3-1', movil: '67632-texto-movil', textoEnFoto: true, textoEnFotoEscritorio: true, id: 67632, campana: 'cyber',
    unidades: 2,   // el banner promete 2x1: la ficha abre con 2 ya elegidas
    ahorro: { antes: '$89.800', ahora: '$44.900', ahorras: '$44.900' },
    alt: 'Cúrcuma con pimienta negra. 2x1 por CyberMonday. 60 cápsulas.',
    titular: 'Cúrcuma <em>con pimienta</em>',
    texto: { arriba: 'CyberMonday', precio: '2x1', abajo: 'el 2º a $0 · hasta agotar stock' } },

  /* [2026-10-03] Escritorio hecho COMPLETO por gpt-image-2 (texto, 2x1 y frasco
     real), estilo de los de celular: herramientas/cyber-escritorio-v3.py.
     [anterior: Claude Code] img: '35868-cyber' (compuesto por código) */
  { img: '35868-cyber-v3-1', movil: '35868-texto-movil', textoEnFoto: true, textoEnFotoEscritorio: true, id: 35868, campana: 'cyber',
    unidades: 2,   // el banner promete 2x1: la ficha abre con 2 ya elegidas
    ahorro: { antes: '$89.800', ahora: '$44.900', ahorras: '$44.900' },
    alt: '15 Day Cleanse: limpieza en 15 días. 2x1 por CyberMonday.',
    titular: 'Limpieza <em>en 15 días</em>',
    texto: { arriba: 'CyberMonday', precio: '2x1', abajo: 'el 2º a $0 · hasta agotar stock' } },

  /* ─── OFERTA DE HALLOWEEN: CURVY GUMMIES ──────────────────────────────────
     [2026-10-01] Jacsson mandó el banner hecho (la misma escena de la entrada,
     con la mano del muerto sosteniendo el frasco). Eligió Curvy Gummies sobre
     Hallprost, y los números le dan la razón: es el ÚNICO de los candidatos con
     ventas reales (300 contra 0), tiene 2.607 visitas, cuesta $2.500 menos y es
     de NIBRESMA, el proveedor de casi toda la tienda.

     Y calza con la campaña sin forzar nada: la portada dice "TODO DULCE, SIN
     TRUCOS" y esto es, literalmente, un caramelo blando. Lo dice su etiqueta.

     Su imagen venía en 16:9 (1672x941) y el hero es 1800x651, mucho más ancho.
     Se recortó la franja y=95..700, que es la única que deja el frasco entero,
     las tres calabazas y la luna completa. El original está en
     ${AS_A}img-halloween-banner-curvy-original.png.

     ⚠️ EL PRECIO NO VA QUEMADO EN LA IMAGEN, va en `texto` y se pinta por HTML.
     Así se lee nítido en cualquier pantalla, se puede cambiar sin rehacer el
     banner y usa la misma tipografía que el resto de la campaña. */
  { img: '49208-curvy', movil: '49208-curvy-movil', id: 49208, campana: 'halloween',
    alt: 'Curvy Gummies: gomitas de aguaje y fenogreco, con probióticos y prebióticos. Lleva 2 y el segundo por $9.000. 160 gomitas.',
    texto: { arriba: 'Halloween se acaba, el 2x1 también', precio: '2x1', abajo: 'el segundo a $0 · hasta agotar stock' } },

  /* ─── OFERTA NUEVA DE HALLOWEEN, ESPERANDO EL BANNER ──────────────────────
     [2026-09-30] Jacsson pidió una oferta nueva para poder mandar una imagen.
     Se eligió Hallprost Ultra (65555) por tres motivos medidos, no por gusto:

       1. Es PEPA DE CALABAZA. De los 47 productos del catálogo es el único que
          es literalmente una calabaza, y la campaña entera está llena de ellas.
       2. Tiene 3.975 visitas en Dropi y CERO ventas. Es el producto con más
          interés sin convertir de todo el proveedor NIBRESMA.
       3. Es de NIBRESMA, el mismo proveedor de casi toda la tienda, así que
          llega en un solo envío (ver la regla "un banner = un proveedor").

     El precio NO se inventó: sale de la tabla maestra, igual que los demás.
       1 u $44.900 · 2 u $53.900 · 3 u $62.900  →  el 2º sale $9.000.

     ⚠️ ESTÁ APAGADO. `pendiente: true` lo saca del carrusel para que no quede
     un hueco mientras no existan las dos imágenes. Para encenderlo:
       1. dejar en ${AS_A}img-banners-
            65555-prostata.webp        1800 × 651  (escritorio)
            65555-prostata-movil.webp  1080 × 1350 (celular)
       2. borrar la línea `pendiente: true`.
     No hay que tocar nada más: el sello del 2º por $9.000 y el bloqueo del
     descuento de bienvenida ya están puestos abajo. */
  { img: '65555-prostata', movil: '65555-prostata-movil', id: 65555, pendiente: true,
    alt: 'Hallprost Ultra: pepa de calabaza y óxido de zinc, para la rutina del hombre después de los 40. Lleva 2 y el segundo por $9.000. 60 cápsulas, 36 g.' }
];



/* ═══ LA ESCENA DE HALLOWEEN ═════════════════════════════════════
   [2026-09-30] Ahora es una ILUSTRACIÓN, no un dibujo hecho con paths.

   Jacsson mandó la imagen (la dejó en el buzón 101 - Recursos - J) y pidió:
   *"copia este mismo diseño pero agrega los efectos de iluminación en las
   calabazas y en la casa"*. Antes de esto yo había dibujado la casa, el árbol y
   las calabazas a mano tres veces y las tres se vieron mal (ver el respaldo
   app.js.bak-copyronda-2026-09-29). Con la ilustración de verdad, el trabajo
   pasa a ser el correcto: ponerle LUZ y MOVIMIENTO encima, no redibujarla.

   Cómo se le pone luz sin tocar la imagen:
     · una capa de focos con mix-blend-mode: screen, que SOLO aclara;
     · cada foco va justo donde la foto ya tiene fuego. Las 7 posiciones NO son
       a ojo: se contaron los píxeles naranjos de la imagen y se sacaron sus
       centros (49,7%/76,2% la calabaza del medio, 3,1%/61,9% la casa, etc.);
     · el parpadeo va en pasos desparejos, porque una vela no late a compás.

   Archivos: ${AS_A}img-halloween-escena.webp (1774x887, escritorio) y
   escena-movil.webp (1080x1350, recorte 4:5 con las calabazas y la luna).
   El original sin comprimir queda en escena.png. */
const HW_BAT = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-62 2 124 46'%3E%3Cg fill='%23120E22'%3E%3Cpath id='a' d='M5 20C16 9 31 6 45 10c-6 4-9 10-7 17-7-5-15-5-21 1-3 3-7 5-12 5z'/%3E%3Cuse href='%23a' transform='scale(-1,1)'/%3E%3Cellipse cx='0' cy='26' rx='5.5' ry='9'/%3E%3Ccircle cx='0' cy='15' r='4.6'/%3E%3Cpath d='M-4.6 12l-1.6-6.5 4.6 3.6zM4.6 12l1.6-6.5-4.6 3.6z'/%3E%3C/g%3E%3C/svg%3E\")";

/* Los 7 focos: [x%, y%, diámetro en % del ancho, clase de ritmo].
   Los tres últimos se apagan en el teléfono porque el recorte 4:5 los deja fuera. */
const HW_FOCOS = [
  [49.7, 76.2, 20, ''],          // calabaza del medio
  [42.1, 78.8, 13, 'v2'],        // calabaza izquierda
  [57.3, 77.0, 13, 'v3'],        // calabaza derecha
  [3.1,  61.9, 11, 'v4 hw-solo-esc'],   // ventanas de arriba de la casa
  [4.2,  77.1, 11, 'v5 hw-solo-esc'],   // ventanas de abajo
  [90.5, 80.7,  8, 'v6 hw-solo-esc'],   // calabacita del fondo
  [97.9, 86.0,  7, 'v7 hw-solo-esc'],   // la más chica
];

function escenaHalloween() {
  const focos = HW_FOCOS.map(([x, y, r, c]) =>
    `<i class="${c}" style="--x:${x}%;--y:${y}%;--r:${r}%"></i>`).join('');

  const bats = [[9, 17, 0, 34], [17, 23, -7, 26], [25, 29, -14, 20], [6, 21, -18, 22]]
    .map(([top, dur, del, w]) =>
      `<b data-bat style="top:${top}%;--w:${w}px;--t:${dur}s;--d:${del}s"></b>`).join('');

  return `
    <picture>
      <source media="(max-width: 759px)" srcset="${AS_A}img-halloween-escena-movil.webp">
      <img class="hw-foto" src="${AS_A}img-halloween-escena.webp" alt="" fetchpriority="high">
    </picture>

    <div class="hw-luces" aria-hidden="true">${focos}</div>
    <div class="hw-vuelo" aria-hidden="true">${bats}</div>
    <div class="hw-niebla" aria-hidden="true" style="--b:-105px;--o:.26;--t:26s"></div>
    <div class="hw-niebla" aria-hidden="true" style="--b:-70px;--o:.15;--t:40s"></div>

    <div class="hw-ancla" aria-hidden="true">
      <div class="hw-sello">
        <span class="peq">Hasta</span>
        <span class="num">${STORE.welcomeMax}%</span>
        <span class="pie">de descuento</span>
      </div>
    </div>

    <div class="hw-texto">
      <span class="hw-chip">Hasta el ${CAMPANA.hastaTexto}</span>
      <h2>Todo dulce,<br>sin trucos</h2>
      <p>Elige 3 cartas y llévate tu descuento.
         <b>Nadie se va con las manos vacías.</b></p>
      <button class="hw-cta" type="button" data-open-game>Elegir mis 3 cartas ${ic('arrow')}</button>
    </div>`;
}

/* Pinta el murciélago en cada elemento marcado.

   ⚠️ NO SE PUEDE poner el dibujo dentro de style="…". El data-URI del SVG lleva
   comillas dobles y espacios, así que cierra el atributo antes de tiempo y el
   navegador se queda con background-image: url(""). Estuvo así y no se notó
   porque la silueta simplemente no aparecía. Se asigna por JS y no vuelve a pasar. */
const pintarBats = (raiz) => {
  raiz.querySelectorAll('[data-bat]').forEach((el) => { el.style.backgroundImage = HW_BAT; });
};

/* ═══ LOS MURCIÉLAGOS QUE RONDAN LA PÁGINA ═══════════════════════════════════
   [2026-09-29] Jacsson: *"las arañas podrían ir alrededor de la página, por el
   catálogo y otras partes, también los esqueletos y las calabazas, deberían ir
   en distintos lados de la página"*.

   Va SOLO con murciélagos, y es a propósito. De todo lo que se dibujó en código,
   la silueta del murciélago es la única que aguanta: es una silueta, y una
   silueta chica no tiene detalle que salga mal. La araña, el esqueleto y la
   calabaza sí lo tienen, y dibujados a mano se ven como la casa embrujada que él
   acaba de rechazar. Entran cuando estén los PNG de ${AS_A}img-halloween-.

   Reglas que no se rompen:
     · `z-index: -1` dentro de la sección: quedan DETRÁS del texto, nunca encima.
     · `pointer-events: none`: no se comen un clic.
     · van en la FRANJA DE RELLENO de la sección, en px desde el borde, no en %
       del alto: en el teléfono el contenido llena el ancho y los % no sirven.
     · una sección por medio, no todas: si están en cada una, es plaga. */
function adornosRonda() {
  if (CAMPANA.id !== 'halloween') return 0;
  if (document.body.dataset.page === 'test') return 0;

  /* [y desde el borde de arriba (px) | ancho | duración | desfase]

     TODOS van anclados ARRIBA. Probé con algunos anclados abajo y uno quedó
     tapando al 100% el párrafo "Sin pagar nada por adelantado": la franja de
     abajo de una sección no está libre, ahí termina el último texto. La de
     arriba sí, porque después del borde viene la etiqueta de sección. */
  const PAUTA = [
    [[24, 36, 21, 0], [46, 24, 29, -11]],
    [[34, 30, 25, -6]],
    [[26, 34, 23, -14], [48, 23, 31, -3]],
    [[30, 32, 27, -9]],
  ];

  /* Cada página arma sus bloques distinto: el inicio usa `section.sec`, el
     catálogo usa `section.sec-tight`, y la ficha de producto y los kits no traen
     <section> ninguno —ahí se cuelga del <main>—. Probé solo con `.sec` y el
     catálogo quedaba sin un solo murciélago, que es justo donde él los pidió. */
  let secciones = Array.from(document.querySelectorAll('section.sec, section.sec-tight'))
    .filter((s) => !s.classList.contains('final'))
    .filter((s, i) => i % 2 === 0)
    .slice(0, PAUTA.length);
  if (!secciones.length) secciones = Array.from(document.querySelectorAll('main')).slice(0, 1);

  let puestos = 0;
  secciones.forEach((sec, i) => {
    const capa = document.createElement('div');
    capa.className = 'hw-ronda';
    capa.setAttribute('aria-hidden', 'true');
    capa.innerHTML = PAUTA[i].map(([y, w, dur, del]) => {
      puestos += 1;
      return `<i data-bat style="top:${y}px;--w:${w}px;--t:${dur}s;--d:${del}s"></i>`;
    }).join('');
    sec.prepend(capa);
    pintarBats(capa);
  });
  return puestos;
}

/* ═══ LA ENTRADA DE HALLOWEEN ════════════════════════════════════════════════
   [2026-09-29] Jacsson, después de ver dos intentos que no le gustaron:

     · *"debe cubrir toda la pantalla, no solo el banner"*
     · *"no debe ser un banner… simplemente aparece al inicio como una especie
        de pop-up y debe tener una X visible para cerrar"*
     · *"algo similar a como empiezan los Simpson, con esas nubes que se
        destapan y aparece el logo"*

   Así que es un pop-up a pantalla completa: dos masas de nubes tapan todo, se
   abren hacia los lados y detrás queda la escena con la oferta.

   ⚠️ ESPERANDO ARTE. Las nubes están hechas con degradados y ahí está el techo:
   se leen como bruma, no como las nubes dibujadas de los Simpson. Cuando llegue
   `${AS_A}img-halloween-nubes.png` se cambia el `background-image` de
   `.hw-nube .frente` y `.atras` por la imagen y sube de nivel de golpe. */
function introHalloween() {
  if (CAMPANA.id !== 'halloween') return false;
  if (document.body.dataset.page === 'test') return false;

  const caja = document.createElement('div');
  caja.className = 'hw-intro';
  caja.setAttribute('role', 'dialog');
  caja.setAttribute('aria-modal', 'true');
  caja.setAttribute('aria-label', CAMPANA.nombre);
  caja.innerHTML = `
    <!-- La clase hs-escena es la que le da los estilos a la escena (cielo,
         luna, tipografia, silueta). Sin ella el contenido sale sin estilo: el
         titulo gris y la silueta flotando en medio.
         OJO: nada de comillas invertidas en este comentario; va dentro de una
         plantilla de texto de JavaScript y la cortarian. -->
    <div class="hw-fondo hs-escena">${escenaHalloween()}</div>
    <div class="hw-nube izq" aria-hidden="true"><span class="atras"></span><span class="frente"></span></div>
    <div class="hw-nube der" aria-hidden="true"><span class="atras"></span><span class="frente"></span></div>
    <div class="hw-bruma" aria-hidden="true"></div>
    <button class="hw-cerrar" type="button" aria-label="Cerrar la oferta de Halloween">${ic('x')}</button>`;
  document.body.appendChild(caja);
  pintarBats(caja);
  document.body.classList.add('hw-sin-scroll');

  /* Se abre en el cuadro siguiente: si se hace en el mismo, el navegador no
     alcanza a pintar el estado cerrado y no hay transición que ver. */
  requestAnimationFrame(() => requestAnimationFrame(() => caja.classList.add('abierto')));

  const cerrar = () => {
    caja.classList.add('yendose');
    document.body.classList.remove('hw-sin-scroll');
    setTimeout(() => caja.remove(), 620);
    document.removeEventListener('keydown', porTecla);
    /* Recién ahora puede aparecer el juego del descuento: si no, los dos
       pop-ups se pisan en los primeros segundos. */
    document.dispatchEvent(new CustomEvent('hw-intro-cerrada'));
  };
  const porTecla = (e) => { if (e.key === 'Escape') cerrar(); };

  caja.querySelector('.hw-cerrar').addEventListener('click', cerrar);
  document.addEventListener('keydown', porTecla);
  /* El botón de la oferta cierra la entrada y abre el juego. */
  caja.querySelector('[data-open-game]')?.addEventListener('click', () => setTimeout(cerrar, 120));
  /* El foco al botón de cerrar, para que se pueda salir con el teclado. */
  setTimeout(() => caja.querySelector('.hw-cerrar').focus({ preventScroll: true }), 3000);
  return true;
}

function heroSlider(el) {
  if (!el) return;
  /* [2026-09-29, corregido] La escena de Halloween llegó a estar AQUÍ, como un
     banner más. Jacsson lo revisó y pidió otra cosa: *"no debe ser un banner,
     no debe cambiar avanzando hacia el lado; simplemente aparece al inicio como
     una especie de pop-up y debe tener una X visible para cerrar"*, a pantalla
     completa y con nubes que se abren, como la entrada de Los Simpson.
     Eso vive ahora en `introHalloween()`. El carrusel vuelve a ser solo de
     productos. */
  /* Se saltan dos tipos de banner:
     · `pendiente`: todavía no tiene imagen, saldría un hueco;
     · `campana`: es de una campaña concreta. El banner de Curvy es una escena de
       Halloween con calabazas, y en pleno CyberMonday quedaría fuera de lugar.
       Vuelve solo el 8 de octubre, cuando entre Halloween. */
  /* Los banners de la campaña van PRIMERO: en un Cyber de 72 horas, lo primero
     que se ve tiene que ser la oferta del Cyber, no el banner de siempre. Los
     genéricos quedan detrás para que el carrusel siga teniendo variedad. */
  /* [2026-10-03] SOLO LOS BANNERS DE LA CAMPAÑA. Jacsson: *"los banners normales
     igual sácalos, esos volverán después, ahora dejaremos solo los del cyber"*.

     Si la campaña activa tiene banners propios, el carrusel muestra SOLO esos.
     Los de siempre no se borran: vuelven solos en cuanto la campaña termine,
     porque entonces no hay banners de campaña y gana el `else`. */
  /* [2026-10-03] `desde` / `hasta` (fecha ISO): el banner se ve solo en ese rango.
     Sirve para cambiar solo la versión "Nos adelantamos al Cyber" por la que
     tiene fecha, el 5 de octubre a las 00:00, sin que nadie toque nada.
     [anterior] const todos = HERO_BANNERS.filter((b) => !b.pendiente); */
  const ahora = Date.now();
  const todos = HERO_BANNERS.filter((b) => !b.pendiente
    && (!b.desde || ahora >= new Date(b.desde).getTime())
    && (!b.hasta || ahora <= new Date(b.hasta).getTime()));
  const deCampana = todos.filter((b) => b.campana && b.campana === CAMPANA.id);
  const LISTA = deCampana.length ? deCampana : todos.filter((b) => !b.campana);
  let N = LISTA.length;
  /* [anterior: Codex, 2026-09-20] url('${AS_A}img-...') resolvía desde
     styles.css como /assets/${AS_A}img-... y el fondo no cargaba. */
  /* [2026-09-21, Claude Code] El arreglo de Codex usaba '/${AS_A}img-...', con la
     barra al inicio: eso apunta a la raíz del dominio. Funciona en el servidor
     local, pero no si la tienda vive en una subcarpeta (el artifact, o un tema
     de Shopify, que sirve los archivos desde su CDN). Se arma la dirección
     completa desde la página, que funciona en cualquier lado. */
  const BANNERS_URL = AS_A + 'img-banners-';

  /* [2026-10-03] EL BANNER LLEVA DIRECTO A LA FICHA. Antes caía en
     `productos.html#p<id>`: el catálogo entero, con el producto marcado en
     medio de otros cuarenta. El cliente que venía por UNA oferta tenía que
     volver a buscarla. Jacsson: *"mientras más pasos le ahorramos al cliente
     hasta la compra, es más posible que este compre"*. Cada pantalla de más
     entre el anuncio y el botón pierde gente, y el catálogo además lo distrae
     con nuestros propios competidores.

     `u` son las unidades con las que abre la ficha: si el banner promete 2x1,
     llega con 2 ya elegidas y el precio YA es el de la promesa. Un banner
     genérico (el que no habla de un solo producto) conserva su propio `href`. */
  /* [2026-10-03] HASTA CUÁNDO DURA. Jacsson: *"me di cuenta que ningún banner
     dice que es solo por este cyber"*. Y tenía razón: la foto dice "2x1" y nada
     más. Un 2x1 sin fecha no es una oferta, es el precio — y si es el precio,
     no hay ningún motivo para comprar HOY. La fecha es lo que convierte el
     "qué buena oferta" en "la compro ahora".

     Va por HTML, no quemada en la foto, por dos motivos: ninguna imagen hay que
     rehacer, y la frase sale de la campaña activa, así que el día que entre el
     Black Friday cambia sola. En celular la foto ya trae el "2x1" dibujado y
     esta tira es lo ÚNICO que da el plazo: por eso no se esconde. */
  const plazoBanner = () =>
    `Solo por ${CAMPANA.nombre} · hasta el ${CAMPANA.hastaTexto}`;

  const destinoBanner = (b) => {
    if (b.href) return b.href;
    return 'producto.html?id=' + b.id + (b.unidades ? '&u=' + b.unidades : '');
  };

  if (el.querySelector('[data-hs-track]')) {
    el.querySelectorAll('[data-hs-slide]').forEach((s) => {
      const d = s.dataset.desde, h = s.dataset.hasta;
      if ((d && ahora < new Date(d).getTime()) || (h && ahora > new Date(h).getTime())) s.remove();
    });
    const conC = [...el.querySelectorAll('[data-hs-slide]')].filter((s) => s.dataset.campana && s.dataset.campana === CAMPANA.id);
    el.querySelectorAll('[data-hs-slide]').forEach((s) => { if (conC.length ? !conC.includes(s) : s.dataset.campana) s.remove(); });
    N = el.querySelectorAll('[data-hs-slide]').length;
    if (!N) { el.hidden = true; return; }
    el.querySelectorAll('[data-plazo]').forEach((p) => { p.textContent = plazoBanner(); });
    el.querySelectorAll('[data-hs-slide]').forEach((s, k) => { s.setAttribute('aria-label', (k + 1) + ' de ' + N); if (k) s.setAttribute('aria-hidden', 'true'); });
    el.querySelector('.hs-dots').innerHTML = Array.from({ length: N }, (_, k) => `<button class="hs-dot" type="button" role="tab" data-hs-dot="${k}" aria-label="Banner ${k + 1}" aria-selected="${k === 0}"></button>`).join('');
    if (N < 2) el.querySelectorAll('.hs-arrow, .hs-dots').forEach((x) => { x.hidden = true; });
  } else el.innerHTML = `
    <div class="hs-track" data-hs-track>
      ${LISTA.map((b, i) => `
        <article class="hs-slide${b.textoEnFoto ? ' con-texto' : ''}${b.textoEnFotoEscritorio ? ' con-texto-esc' : ''}" data-hs-slide style="--hs-bg: url('${BANNERS_URL}${b.img}.${b.ext || 'webp'}')"
                 role="group" aria-roledescription="Banner" aria-label="${i + 1} de ${N}" ${i ? 'aria-hidden="true"' : ''}>
          ${`
          <a class="hs-link" href="${destinoBanner(b)}" ${i ? 'tabindex="-1"' : ''}>
            <picture>
              ${b.movil ? `<source media="(max-width: 759px)" srcset="${AS_A}img-banners-${b.movil}.${b.ext || 'webp'}">` : ''}
              <img class="hs-img" src="${AS_A}img-banners-${b.img}.${b.ext || 'webp'}" alt="${b.alt}"
                   loading="${i ? 'lazy' : 'eager'}" fetchpriority="${i ? 'low' : 'high'}" decoding="async">
            </picture>
          </a>`}
          ${b.titular ? `
          <div class="hs-titular" aria-hidden="true">${b.titular}</div>` : ''}
          ${b.ahorro ? `
          <div class="hs-ahorro" aria-hidden="true">
            <span class="fila">
              <span class="antes">${b.ahorro.antes}</span>
              <span class="ahora">${b.ahorro.ahora}</span>
              <span class="gana">Ahorras ${b.ahorro.ahorras}</span>
            </span>
            <span class="plazo">${plazoBanner()}</span>
          </div>` : ''}
          ${b.texto ? `
          <div class="hs-oferta" aria-hidden="true">
            <span class="arriba">${b.texto.arriba}</span>
            <span class="precio">${b.texto.precio}</span>
            <span class="abajo">${b.texto.abajo}</span>
          </div>` : ''}
        </article>`).join('')}
    </div>
    <button class="hs-arrow prev" type="button" aria-label="Banner anterior" data-hs-prev></button>
    <button class="hs-arrow next" type="button" aria-label="Banner siguiente" data-hs-next></button>
    <div class="hs-dots" role="tablist" aria-label="Elegir banner">
      ${LISTA.map((b, i) => `<button class="hs-dot" type="button" role="tab" data-hs-dot="${i}" aria-label="Banner ${i + 1}" aria-selected="${i === 0}"></button>`).join('')}
    </div>`;

  const track = el.querySelector('[data-hs-track]');
  const slides = [...el.querySelectorAll('[data-hs-slide]')];
  const dots = [...el.querySelectorAll('[data-hs-dot]')];
  const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let i = 0, timer = null;

  function ir(n) {
    i = (n + N) % N;
    track.style.transform = `translateX(${-i * 100}%)`;
    slides.forEach((s, k) => {
      if (k === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      const a = s.querySelector('.hs-link');
      if (a) a.tabIndex = k === i ? 0 : -1;
    });
    dots.forEach((d, k) => d.setAttribute('aria-selected', k === i));
  }
  function andar() { if (!quieto && !timer) timer = setInterval(() => ir(i + 1), 6500); }
  function parar() { clearInterval(timer); timer = null; }
  function reiniciar() { parar(); andar(); }

  el.querySelector('[data-hs-prev]').onclick = () => { ir(i - 1); reiniciar(); };
  el.querySelector('[data-hs-next]').onclick = () => { ir(i + 1); reiniciar(); };
  dots.forEach((d, k) => { d.onclick = () => { ir(k); reiniciar(); }; });
  el.addEventListener('mouseenter', parar);
  el.addEventListener('mouseleave', andar);
  el.addEventListener('focusin', parar);
  el.addEventListener('focusout', (e) => { if (!el.contains(e.relatedTarget)) andar(); });
  el.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { ir(i + 1); reiniciar(); }
    if (e.key === 'ArrowLeft') { ir(i - 1); reiniciar(); }
  });
  /* deslizar con el dedo */
  let x0 = null;
  el.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; parar(); }, { passive: true });
  el.addEventListener('touchend', (e) => {
    if (x0 === null) return;
    const d = e.changedTouches[0].clientX - x0;
    if (Math.abs(d) > 40) ir(i + (d < 0 ? 1 : -1));
    x0 = null; andar();
  });
  document.addEventListener('visibilitychange', () => (document.hidden ? parar() : andar()));
  ir(0); andar();
}

/* [2026-10-05 Claude Code] Letrero «Muy pronto» para lo que aún no está terminado.
   Marca (y deja sin efecto) los enlaces de tarjetas apagadas (.need-chip.off) y los que
   apunten a una dirección de la lista `AS.pronto` (la llena el tema de Shopify). Cuando una
   sección esté lista, se saca su dirección de la lista y el letrero desaparece solo. */
function muyPronto(raiz) {
  const lista = (window.AS && window.AS.pronto) || [];
  (raiz || document).querySelectorAll('a[href]').forEach((a) => {
    if (a.dataset.pronto) return;
    const h = a.getAttribute('href') || '';
    const apagada = a.classList.contains('need-chip') && a.classList.contains('off');
    const enLista = lista.some((x) => h === x || h.startsWith(x + '?') || h.startsWith(x + '#'));
    if (!apagada && !enLista) return;
    a.dataset.pronto = '1';
    a.classList.add('pronto');
    a.setAttribute('aria-disabled', 'true');
    /* Los íconos de la cabecera no llevan letrero escrito (se montaba sobre el carrito): solo el aviso al tocar. */
    if (a.classList.contains('icon-btn')) { a.title = (window.AS && window.AS.avisos && window.AS.avisos.pronto) || 'Muy pronto'; return; }
    const tag = document.createElement('small');
    tag.className = 'pronto-tag';
    tag.textContent = (window.AS && window.AS.avisos && window.AS.avisos.pronto) || 'Muy pronto';
    a.appendChild(tag);
  });
  /* Secciones enteras que aún no funcionan (se reconocen por el texto de su etiqueta). Para
     apagar el letrero de una, sacar su texto de esta lista. */
  const SECCIONES_PRONTO = ['Muro de clientes', 'A los 30 días'];
  /* [2026-10-05] En Shopify cada sección trae su casilla "Muy pronto" (data-pronto-seccion): manda esa,
     y la lista de arriba queda solo para la web de la bóveda. */
  const enShopify = !!(window.AS && window.AS.variantes);
  (raiz || document).querySelectorAll('.eyebrow').forEach((e) => {
    const marcada = e.closest('[data-pronto-seccion]') && e === e.closest('[data-pronto-seccion]').querySelector('.eyebrow');
    if (e.dataset.pronto || !(marcada || (!enShopify && SECCIONES_PRONTO.includes(e.textContent.trim())))) return;
    e.dataset.pronto = '1';
    const tag = document.createElement('small');
    tag.className = 'pronto-tag';
    tag.textContent = (window.AS && window.AS.avisos && window.AS.avisos.pronto) || 'Muy pronto';
    e.appendChild(tag);
  });
}

function boot(extra) {
  chrome();
  menuTienda();
  bunting();
  reviews();
  personas();
  brandsBar();
  introHalloween();
  adornosRonda();
  heroSlider(document.querySelector('[data-hero]'));
  if (extra) extra();
  discountGame();
  document.querySelectorAll('[data-ic]').forEach((el) => el.insertAdjacentHTML('afterbegin', ic(el.dataset.ic)));
  document.querySelectorAll('.stars:empty').forEach((el) => { el.innerHTML = ic('star').repeat(5); });
  revealGroups();
  headerScroll();
  countdowns();
  countUps();
  reveal();
  muyPronto();
  document.addEventListener('click', (e) => {
    const pr = e.target.closest('a[data-pronto]');
    if (pr) { e.preventDefault(); toast((window.AS && window.AS.avisos && window.AS.avisos.pronto_aviso) || 'Muy pronto: estamos terminando esta sección.'); return; }
    /* [Tema Shopify] el carrito es el de Shopify (as-tienda.js) */

    /* Elegir cuántas unidades lleva: cambia el precio de esa tarjeta.
       El descuento de bienvenida es un monto fijo con mínimo de unidades, así que
       elegir 2 o 3 lo ACTIVA en vez de anularlo: la línea guarda cuántas lleva y
       sobre qué precio se descuenta. */
    const op = e.target.closest('[data-pack]');
    if (op) {
      const caja = op.closest('.p-packs');
      const opciones = [...caja.querySelectorAll('[data-pack]')];
      opciones.forEach((b) => {
        b.classList.toggle('on', b === op);
        b.setAttribute('aria-checked', b === op);
      });
      /* En el catálogo el contenedor es la tarjeta; en la página de producto es
         el bloque de la ficha. Si no se busca en los dos, el clic revienta en la
         ficha porque ahí no hay ninguna `.p-card` alrededor del precio. */
      const tarjeta = op.closest('.p-card, .pd-info');
      if (!tarjeta) return;
      const precio = tarjeta.querySelector('[data-precio]');
      if (precio) precio.textContent = clp(+op.dataset.pack);
      const linea = tarjeta.querySelector('[data-disc-price]');
      if (linea) {
        linea.dataset.discPrice = op.dataset.pack;
        linea.dataset.unidades = opciones.indexOf(op) + 1;
      }
      if (document.body.classList.contains('has-disc')) aplicaDescuento(tarjeta);
    }
  });
}

/* ═══ Clic derecho y arrastre de imágenes, bloqueados ════════════════════════
   [2026-09-28] Jacsson: *"eliminar la opción que permite seleccionar el texto y
   el clic derecho de la página"*. La selección se bloquea en `styles.css`; aquí
   va lo que necesita JavaScript.

   Se bloquea el menú del clic derecho, arrastrar las fotos fuera del navegador
   y copiar con Ctrl+C. En los campos de texto se deja pasar todo, porque si no
   el cliente no puede pegar su correo. */
document.addEventListener('contextmenu', (e) => {
  if (e.target.closest('input, textarea, [contenteditable="true"]')) return;
  e.preventDefault();
});
/* Sin esto, arrastrar una foto al escritorio la descarga igual. */
document.addEventListener('dragstart', (e) => {
  if (e.target.closest('img, picture, a')) e.preventDefault();
});
document.addEventListener('copy', (e) => {
  if (e.target.closest('input, textarea, [contenteditable="true"]')) return;
  e.preventDefault();
});
